<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{
    "num_cand": "U2FsdGVkX1/8pSTHSA7yR4PoZcWmCT+d8dQRbVBzbwM=",
    "cpf": "U2FsdGVkX1+K17vC/e9skUaym4xA0oGqh32P69s8KLY="
}, {
    "num_cand": "U2FsdGVkX1+h8HT1EjZCR2QaA4ybmLcAMagcegdrjiI=",
    "cpf": "U2FsdGVkX1/Jmtp53gWaVS9tkxa1403XxiCuMQmY5KE="
}, {
    "num_cand": "U2FsdGVkX18zEV0nQSxKg4eE8fR0KlbDO1t+3FSr//0=",
    "cpf": "U2FsdGVkX19zsaCgVCpRW6XI1Aei8i1+N59KbXvZ2lU="
}, {
    "num_cand": "U2FsdGVkX1+QJBSzwIamQX4LdtTF6RUYO0Fdmtr04mg=",
    "cpf": "U2FsdGVkX1/xDxPZT9LRM9kJyvoN4KJWU4kg8pzAvMU="
}, {
    "num_cand": "U2FsdGVkX18+w1feYahpBzZRbxZqCt2p2oX0FKFcukY=",
    "cpf": "U2FsdGVkX19HUISq6erETI+zbfI1ctNQ/KQm7V/9aJU="
}, {
    "num_cand": "U2FsdGVkX18hJ3vPdpRQtIPMKNdDsqsNC9Gmzs0Ekck=",
    "cpf": "U2FsdGVkX1+jldv7VHvrv786yUVJoibl17UMJ8yLbEo="
}, {
    "num_cand": "U2FsdGVkX1+HFZVXky2BTc1rjh8bhjUGrIOMLShBRxM=",
    "cpf": "U2FsdGVkX18zzdzV6wLr1j/CRfljUFTjRF/mJofzlOo="
}, {
    "num_cand": "U2FsdGVkX19283iwA4RzXo3Za51orhzmBQfRpg4rwIw=",
    "cpf": "U2FsdGVkX1+jVTv0XjMme+vgO0itBhJivXDsPbSbkvs="
}, {
    "num_cand": "U2FsdGVkX19X4Tn0VP1m4aVN7TCIv5APwD4dEfw4MQM=",
    "cpf": "U2FsdGVkX19xRxWdoP+gcN8hCaNQPwERMTgpo0A80Ck="
}, {
    "num_cand": "U2FsdGVkX1/EGtJ7z1yicAjF6ezufEpueaQEFCudd68=",
    "cpf": "U2FsdGVkX1+RIaPTLp+VYNYX7Nt9CUyf8TbZvmH79TI="
}, {
    "num_cand": "U2FsdGVkX19IGeydSqUSdStERXcIS/B5sm3RgAcNFTc=",
    "cpf": "U2FsdGVkX18QqGXk5W4Cm8uI9ar4rq1ziXcf4TNNy7s="
}, {
    "num_cand": "U2FsdGVkX198+v7KdnW5qXgfwzETcV2EyanvBvsfaP0=",
    "cpf": "U2FsdGVkX1+CHmJZcWpEOfhU9x3owG96OaJPFP+GeSI="
}, {
    "num_cand": "U2FsdGVkX19Hn2W3aqwKYwWllgbN0LPlz0TICw9BJiE=",
    "cpf": "U2FsdGVkX19x/UOrNkzYu6olPg3yXw0PQTso246LNfY="
}, {
    "num_cand": "U2FsdGVkX19ht0w5ffOOwtf3cYMu1MT5v2nOJsJ4XG4=",
    "cpf": "U2FsdGVkX18fYkwYgoPqrXkd51QMohuhnJQ74I4CvLM="
}, {
    "num_cand": "U2FsdGVkX1/6RxGcfE3Irv6GH0USUJOucmSlJOHUIDw=",
    "cpf": "U2FsdGVkX19Er+lVPUGGAyGI4r+813d31XAuzdzEo0o="
}, {
    "num_cand": "U2FsdGVkX180wpmYZ4BwbQAsVoX0htE256/jUjaDgyQ=",
    "cpf": "U2FsdGVkX19lasYDod9vNsj+yDwJVa2iHeVK/bjMFJw="
}, {
    "num_cand": "U2FsdGVkX18lAOiTvrd4O6rT2TrS+vwj00Q5Hy1hZ3k=",
    "cpf": "U2FsdGVkX1+1tug8VoUuPNOVKbvgMN35DqCFOxyL0k0="
}, {
    "num_cand": "U2FsdGVkX1+DBmvlafRtiAOlylAS9XP2sjibCX7qqtM=",
    "cpf": "U2FsdGVkX18gJwAxA7n29QN5S2Pk91BMXbH6TH/0Aw4="
}, {
    "num_cand": "U2FsdGVkX18x9Vcx9hh0E1PCe3wiYA7tbET9wgVpwpY=",
    "cpf": "U2FsdGVkX1+AtCLs3rEvGfLEeuvMNOzYQzufq+NiRHw="
}, {
    "num_cand": "U2FsdGVkX1/GNETYhBDrn1XlIyo53lWTwCpx7xrQDLU=",
    "cpf": "U2FsdGVkX1+LxtDjf5xcSgrIy+7apKTM5xl9gCE78o8="
}, {
    "num_cand": "U2FsdGVkX1/FgQf9y1UKR5tRW1akbsKs1CQQeGeL9kw=",
    "cpf": "U2FsdGVkX1/49AHSS9Fcet2b3yghoaFA2hpm1ygajvw="
}, {
    "num_cand": "U2FsdGVkX1+pX4j8O3zzQ7ubMkcSkvVkGjoy2PvNAo4=",
    "cpf": "U2FsdGVkX19JHWSdsInxMoorzz/soPLPaCJuv68Jl6k="
}, {
    "num_cand": "U2FsdGVkX1/BeUtaownWrN/ET2rVr2l3473SmuuFqf4=",
    "cpf": "U2FsdGVkX190zS0Hm6IrbkNNrw4hEsi2jEDhqVd7oew="
}, {
    "num_cand": "U2FsdGVkX18YBShLB7znWdOgAFjJAOGDkG5M1HTuVps=",
    "cpf": "U2FsdGVkX18x3cj79PrjF6JZCQckgEexHkTP0ZkTeOY="
}, {
    "num_cand": "U2FsdGVkX18l7cVI82GJl0NykPNRtXVpgsBK9H/C6T4=",
    "cpf": "U2FsdGVkX1/O8U2PYp5OE4B3yRgSU/791svsA/Sum00="
}, {
    "num_cand": "U2FsdGVkX1/CswEhDIUaZzlMtXKhd5nZDeBiE72r5WA=",
    "cpf": "U2FsdGVkX19AQEUtiM96iWCaoNF3REeI6SdWjh+FNfs="
}, {
    "num_cand": "U2FsdGVkX1+sd/1JbTKPZkmQkNgGxIBiIRCHRKFA8F4=",
    "cpf": "U2FsdGVkX1+5QcRmqpvJgy7+d2lqslME+EdcNX61qsw="
}, {
    "num_cand": "U2FsdGVkX1+uy2+PiSM5PGWXnirfLGq8lUa6P8c63BU=",
    "cpf": "U2FsdGVkX1/1hSiYpAjkGIhd1XvCiqW0BTbHxCGdzgk="
}, {
    "num_cand": "U2FsdGVkX18kFbke6leNi0bJNsP26FuxjFFL2orgn2w=",
    "cpf": "U2FsdGVkX19uYtUwOKHNBULj7NiGMYgoUxaXtYqfRos="
}, {
    "num_cand": "U2FsdGVkX18fXeWKirUh5qBKKV/k3kRMnrMueS4IOKU=",
    "cpf": "U2FsdGVkX19W8xTitDDetodoHScx/ZA1MQjpLoTbkdM="
}, {
    "num_cand": "U2FsdGVkX1/lNKC43V9EOY6JZQ/Pt1VQun4dvmPTmAM=",
    "cpf": "U2FsdGVkX1+32yes46D8BSiRapIY6jcoJVYbbcouYK0="
}, {
    "num_cand": "U2FsdGVkX19dqR5KVEDkgLYNhTfLp6q3sdmmwxsjqi4=",
    "cpf": "U2FsdGVkX1+8V2wzEHG4WnOaa3dCmtX0UOXO9rCQSmc="
}, {
    "num_cand": "U2FsdGVkX18F0XvQTwd7FI14+6mbKWqPTvzFQBXE50Q=",
    "cpf": "U2FsdGVkX1+F3xx0P+IyxaGl2s802sEK5RpB1B04FV0="
}, {
    "num_cand": "U2FsdGVkX1+IzYPU9SC8OUM2tY86HBrcksWIFMiL5J8=",
    "cpf": "U2FsdGVkX19SN/TII9UHXrFzLPwWi9n3j6aluXrkGGc="
}, {
    "num_cand": "U2FsdGVkX19RqRhdgMjW0UELTAFUpnO582enXpUfPhY=",
    "cpf": "U2FsdGVkX18C1cGEF2eDkFCo1J9y2jyQcAk+wHLvp8w="
}, {
    "num_cand": "U2FsdGVkX1/UU/pi7uWq9vy+iv1ygp9WSIw521W6hPY=",
    "cpf": "U2FsdGVkX18ll8msujKUSKj/m7Q9oqYKHTz0q8IoDzY="
}, {
    "num_cand": "U2FsdGVkX1+09QXlvwT9S+qps7gf06HBri/287a4/pc=",
    "cpf": "U2FsdGVkX19TyRk0bFvM7Oyo3K2RscIpL5vk6ExnKmw="
}, {
    "num_cand": "U2FsdGVkX1+xFJz8qGdl5X7hfWI8yIuQ4+ku9Z9Hndc=",
    "cpf": "U2FsdGVkX18k8aUEUOaK18VrfDoLdlwhYxSNCqYa1vs="
}, {
    "num_cand": "U2FsdGVkX1+g3x8cSXuQhKIORUVOVF8ucTGRFOTaD8Q=",
    "cpf": "U2FsdGVkX18pXXuPRzq1uxLyp4Gb/kuOqet18VEuebs="
}, {
    "num_cand": "U2FsdGVkX1+/DgpEP/20TSfaYRcO6KH/fyk55QZw2yo=",
    "cpf": "U2FsdGVkX1+DGvtMVmMkooTCPtS4fwoYyA9Aq43SMN4="
}, {
    "num_cand": "U2FsdGVkX19jNEiPE+LmvfNWlm2l4Spu6JbLRWPo1GE=",
    "cpf": "U2FsdGVkX1+hU6AjtrDHVQHEVHiFrQVmpjzvmjt3ilA="
}, {
    "num_cand": "U2FsdGVkX19kbmgv/Q6uBXtsxXVL1d6rh4mBOrUEJy8=",
    "cpf": "U2FsdGVkX18EBfJ1flqpKH+3XeeRPxys8VW+FkfwnTI="
}, {
    "num_cand": "U2FsdGVkX1+RVLtu5TlrtT3o+Qxj+uadX9KrZPH/3Vs=",
    "cpf": "U2FsdGVkX1//O84+ONJP8U51zE3ryYfwhkV9IrFWpBA="
}, {
    "num_cand": "U2FsdGVkX191H2gbEAzzHdaR4+KIodutqIsfOBlwYCA=",
    "cpf": "U2FsdGVkX1/LqYuuIkVr6WtaynUipTWXKDnk4nr1pc4="
}, {
    "num_cand": "U2FsdGVkX19i2U7OgNKPusGRnBvtbJaLTtsSz0TPKtE=",
    "cpf": "U2FsdGVkX1/8JKTbymfV+DCIJWTj8m3uHHjUF/dV5PQ="
}, {
    "num_cand": "U2FsdGVkX18Qk34LceGKgBJQIiVsN0disFUfSbDsaIk=",
    "cpf": "U2FsdGVkX19H4Ha1vuQI/0mA5+eIAui5W6vtX7JbLTA="
}, {
    "num_cand": "U2FsdGVkX19frW1kVa4PngXOM5ZK4M1Y4R4WrGQC2zk=",
    "cpf": "U2FsdGVkX18cdO5fxahUsxcsx8SZMKXvXoj9yW/8N3A="
}, {
    "num_cand": "U2FsdGVkX18eM4+FpN56EG28EDeIxPvJKH+KbYsvOyU=",
    "cpf": "U2FsdGVkX18h7uif0uihE1lnRUuHxbyFZ/gUQN4HWAs="
}, {
    "num_cand": "U2FsdGVkX190/pJ0K6x+Si7dMQl5SsTMGpLmFauVL4I=",
    "cpf": "U2FsdGVkX19ExJimkJjZ8f+j2yjQjJX/vzgM4WxzhX8="
}, {
    "num_cand": "U2FsdGVkX19a+9PRaq9bEjNjbLZicZbR/tL4veyRQ6U=",
    "cpf": "U2FsdGVkX1+zQ4dFtg6ZByVmwgkqAgTVo6RJS/MDRfg="
}, {
    "num_cand": "U2FsdGVkX1+q3XZ6zxt1dPMYg1FoZrR/ZCYiO99pXVc=",
    "cpf": "U2FsdGVkX185bzQp9U7MuzoBWLOTorShQHo8x8g91PI="
}, {
    "num_cand": "U2FsdGVkX18Y//cbw2agITpkzSm3Y1McBRHyhg23er4=",
    "cpf": "U2FsdGVkX19+a8WIO4Cs1hoaNpenKq/+HaaDJJCyZsM="
}, {
    "num_cand": "U2FsdGVkX1+gKEpqPtt3jnx54rAed4Z/TRKsmHgB3g4=",
    "cpf": "U2FsdGVkX1+Sg6trhCn8yHJM7oxke2cvZhNtaSCIpDI="
}, {
    "num_cand": "U2FsdGVkX18uItzLX+QoJiibQ6bZ1VU3YpUmhWHLaEM=",
    "cpf": "U2FsdGVkX18fs8qZtKPmKmI8bjLn/IFSjQco/7mQon0="
}, {
    "num_cand": "U2FsdGVkX18zK6P7nUvqt4LfbrowUEX6qRNZgnxPFgg=",
    "cpf": "U2FsdGVkX1/tNvESKPyyHRB6kcI+tOpDqufRsYKBfPc="
}, {
    "num_cand": "U2FsdGVkX1+2IKcL4SVzqLdb4YLW2wka1peIaGbbFUo=",
    "cpf": "U2FsdGVkX1+yfxk+iaPkEU75k+aWcRsq/L8Yvfmjrxw="
}, {
    "num_cand": "U2FsdGVkX1+pgrO2Fqhsos4Y0td6C+bCsVjIIqFSi9o=",
    "cpf": "U2FsdGVkX1/2ZuJx3TqEnD/mWu6j/X5DfJXbxiXvnrs="
}, {
    "num_cand": "U2FsdGVkX18e7NBwoKuI7cYfOMaauGlejaAaCpkIf2A=",
    "cpf": "U2FsdGVkX18C6pTdAlggr4mV6Js2jcReLxwk8NuHcUk="
}, {
    "num_cand": "U2FsdGVkX19a5YNomTTx+J6RwHV270UCl87eDixK0Rc=",
    "cpf": "U2FsdGVkX18gCHTW0Yqk7SXx+bC7JDLU8lXifNHpaLY="
}, {
    "num_cand": "U2FsdGVkX1/NJw+h4YyV45Mda2ZuDUgXGPxbCdpZdlQ=",
    "cpf": "U2FsdGVkX1/nMFh6U4MN+f9bCxcydHdLyowZTdBhC7k="
}, {
    "num_cand": "U2FsdGVkX19wyUcHTkm98dpQxmaHPKm9tJ5rDI5zfpk=",
    "cpf": "U2FsdGVkX198Y7mpMLM8GjT6XY+mDWdbAQSIX+pnImI="
}, {
    "num_cand": "U2FsdGVkX1+0WniatIx6HtG1lMcM21H5QWGjqOw8CEA=",
    "cpf": "U2FsdGVkX1/HyY9/XHErKtwP2AbdfxFmIs32vDwbYaA="
}, {
    "num_cand": "U2FsdGVkX1/wq/UXl/CC7GYaeqbDnORPxgw4DOW7T+I=",
    "cpf": "U2FsdGVkX18M/s+874/VjUiJRT2+KTbGUmW3+Bb7W9w="
}, {
    "num_cand": "U2FsdGVkX18AQ64WyhfjlwPiLNtngSwRAN2x8rLasNQ=",
    "cpf": "U2FsdGVkX1/kbKHMkcqFYPizr3VV+VblJJB/feOJYcc="
}, {
    "num_cand": "U2FsdGVkX18xAW9wiigK2TrDkjsfV87xm0BJHHzdcAs=",
    "cpf": "U2FsdGVkX1+bLV7lreeaFmgiaD4SIMENXTtYupU/nKw="
}, {
    "num_cand": "U2FsdGVkX1+dD7muds+JWVopWVXUyZwASlGz/C/uIeE=",
    "cpf": "U2FsdGVkX1+a7LWUoocmv5AS8m83HirynpCIeyISf+s="
}, {
    "num_cand": "U2FsdGVkX1/+SsPHTi8rCLTLJT6GgX5dm2hmbYofRXw=",
    "cpf": "U2FsdGVkX1+laUFeyLEhfc2Dfot/DMr9YSusmexKfVA="
}, {
    "num_cand": "U2FsdGVkX19OEDIo4I9H/fZ8udEukPKQEzO0beC1UKw=",
    "cpf": "U2FsdGVkX18olXYl/wv99nWduluCOnR4d1KEILl9HtM="
}, {
    "num_cand": "U2FsdGVkX18i45veeP6nup0396FKC7CdxB1gDtBllEs=",
    "cpf": "U2FsdGVkX18Vh/d/e6OJfYdn6TEKYwWRnSGPdge93Xk="
}, {
    "num_cand": "U2FsdGVkX1/wXBP6a0bo3YLEasJMbfvKJC7+tPpYf4U=",
    "cpf": "U2FsdGVkX1+NtuaOGeHmJwvOodkH/ZGaIwa4Ul+1U+0="
}, {
    "num_cand": "U2FsdGVkX19VtBVF7qOpLSaEJHmOx3tkPGm/bjLfOpk=",
    "cpf": "U2FsdGVkX1/c/mU8gdFTpoSm5PsG47z//BjomIcYoHM="
}, {
    "num_cand": "U2FsdGVkX1+jOoBmPMufkVPaj06OzpsntmionqxB8E4=",
    "cpf": "U2FsdGVkX19x4YOfJiRsLKuMvPaJhM5mpeidrFF+mRA="
}, {
    "num_cand": "U2FsdGVkX1/HxwSAetQi9HvNyqy8D7ZNKSrLsIgE//A=",
    "cpf": "U2FsdGVkX1/3Rw6bRJdakA1ga0Dtm/eP1dTVUlFZkTw="
}, {
    "num_cand": "U2FsdGVkX18TlytwNq1fd1nrGN26IbZmdI3g6gEJ5qw=",
    "cpf": "U2FsdGVkX18hP4A0FPiyeYGBQ3f81WWG2NOUqUfGG5s="
}, {
    "num_cand": "U2FsdGVkX18WJxQ9IgrNzohsNjcK8OTXBEzvFrVOq0Y=",
    "cpf": "U2FsdGVkX19eR8lsTrHJqgwylqFC+qHRwF2k5i4f/5U="
}, {
    "num_cand": "U2FsdGVkX19x8B5jvh4pvjT0U9ze+FfYvnpXhERAdqM=",
    "cpf": "U2FsdGVkX1/owq3CQiUjF9EDl6MsJMvvzM974HwJzdg="
}, {
    "num_cand": "U2FsdGVkX1+Jg/B6eYgK5hD0Q7NFBe+8tqg/bgbJ2mE=",
    "cpf": "U2FsdGVkX1/f4hXR8b9rzQoIuuv+CmD8EzYURCXkCvY="
}, {
    "num_cand": "U2FsdGVkX1/kopE07VzHtRexJeFMFmCIH7PlPw0yp8Y=",
    "cpf": "U2FsdGVkX1/t9R+M5UwjGiZXzEt38qVlm8InlFt9zDI="
}, {
    "num_cand": "U2FsdGVkX18z9EcoxqM28b69ahIeROOOaPsy1Huy+WA=",
    "cpf": "U2FsdGVkX18DI8XtB0kHtHxCeZZjySO5JSNLc58+8As="
}, {
    "num_cand": "U2FsdGVkX1+SUm4uxgEAQTqyQPrXJkMLZbZ89ZiA3m0=",
    "cpf": "U2FsdGVkX19QP7NRy7W80B+G8Lzk619y7nmNjrnw9Sg="
}, {
    "num_cand": "U2FsdGVkX18+vsjs2h7mk4y42jxHLvb9SAF99yAqlQc=",
    "cpf": "U2FsdGVkX18ppUnZwPu5XZLsqMLi0ZLAQXvz7G9wMdw="
}, {
    "num_cand": "U2FsdGVkX1/mjjwEZPLLIT02Fr8MHcEUAo2DkmJi+Pk=",
    "cpf": "U2FsdGVkX18CfHP9GB3Xmoa4VspG4RVum33gl1NIv6g="
}, {
    "num_cand": "U2FsdGVkX1+6Oc/PDAbtHrcEuTsCuvX26LTXTWzHHPY=",
    "cpf": "U2FsdGVkX19dU0e3aMgp52UrepbTQ1eA4gW+ZS+gxNY="
}, {
    "num_cand": "U2FsdGVkX18duztFghaExC3go8egFiD71Dea48JgLSI=",
    "cpf": "U2FsdGVkX1+9aCFRsdELH3+TOEnd8wYr6F0CiWUTITU="
}, {
    "num_cand": "U2FsdGVkX18RQ0SKUKHJ468KeDbieRKnp5b75o5OCyc=",
    "cpf": "U2FsdGVkX18ifoD3fobv95yh3j5lByIA2RqR9pIJ4+g="
}, {
    "num_cand": "U2FsdGVkX18VPeuUq/65ggyb5DipQBNXAciQnEa3s2M=",
    "cpf": "U2FsdGVkX1/FhBMriBxBpApSdD3PnxTKqjl6hLq3VkE="
}, {
    "num_cand": "U2FsdGVkX1+WsMXcep1mtuAtp8xVfy+gngrMN3WfCFg=",
    "cpf": "U2FsdGVkX1+NEqK8nuSIFKs6aag0oIKrC/hFRwRAjBk="
}, {
    "num_cand": "U2FsdGVkX18gCGqGQuuiH9H+EMAFRXUyhGZmwhoBqJ8=",
    "cpf": "U2FsdGVkX1/hTsjDoQYLm3eWv93aTvCef8DSE4GgKPk="
}, {
    "num_cand": "U2FsdGVkX18qF+0gUttPjxxRo9DiinPuQNBK+SVxekc=",
    "cpf": "U2FsdGVkX1/LPD9edtnNgeatFf1Ri/n0GG/eeqaDjPU="
}, {
    "num_cand": "U2FsdGVkX1+241yZYlZHJrCtJ7Zlryhf/Minmb1rfzw=",
    "cpf": "U2FsdGVkX192PKM4mp9Z5t9n8iPKkcVbUKQtMiUs5nk="
}, {
    "num_cand": "U2FsdGVkX1+SNdHRgKOPZbqnUpikuaVobHXx5/bSboI=",
    "cpf": "U2FsdGVkX19P3YE1VEZagQIGULTzqOUlr6+BCKXfDwQ="
}, {
    "num_cand": "U2FsdGVkX18mun8MRjXR02THC/TJj0SPkYKSj3sEtuM=",
    "cpf": "U2FsdGVkX1+HKFgHEjiQhoZddGHbVSR2RtiF4hFmWGA="
}, {
    "num_cand": "U2FsdGVkX18h+60bysVEi0OQXoCUNQ/pyaDsWOy4Tcs=",
    "cpf": "U2FsdGVkX1+i+gxXl5K1RB4PKe4UkcErjDVei497+0c="
}, {
    "num_cand": "U2FsdGVkX18YOc0AZyj6UkGJvRZgVJZae1wesQgxL/k=",
    "cpf": "U2FsdGVkX1+4Okm4UZtxR57R5UHNo/crsYr+WkA5i84="
}, {
    "num_cand": "U2FsdGVkX19D1fX9Wvzu+sPxwkIraUnEVgrexD/TtNY=",
    "cpf": "U2FsdGVkX1+1jfEkr91jmRPnZfwcWQMpDnlXtkh8gTk="
}, {
    "num_cand": "U2FsdGVkX19s1Aan+tQm4lEyTqlBIEDorGQH/fz0NV0=",
    "cpf": "U2FsdGVkX1/ulW9oHONXp8bBM5cgGvAaWujWu2TeQDc="
}, {
    "num_cand": "U2FsdGVkX182xiuuf3hyH0UmeIWxb+fhAlXKsuI3JbM=",
    "cpf": "U2FsdGVkX1+SXBPZ1nU2I4Mq7QHUgu00kHWoEWbYJJY="
}, {
    "num_cand": "U2FsdGVkX1+/Hmaf252NHPZ0E7VN1pUavNhbK6vrnhA=",
    "cpf": "U2FsdGVkX182HkzJiPhszVA8U0nEs+SdhmR3yp3GVAw="
}, {
    "num_cand": "U2FsdGVkX19DL0A0gZPIPG4VKGbrWdU67qbp1zH6zDk=",
    "cpf": "U2FsdGVkX1+1tUUKpXEQdw9UQHs6W6R4EgLq0S+iyZw="
}, {
    "num_cand": "U2FsdGVkX1/bkjbNDdVCcPKzT7jfcLM1MgkJVV80j5o=",
    "cpf": "U2FsdGVkX1/BKsnutfioDVBZ40t8YkoLGs3YBf5PtbY="
}, {
    "num_cand": "U2FsdGVkX1/xiNtb7R7gNYJjwcRbSysbE31vmIXI5WA=",
    "cpf": "U2FsdGVkX19i8Cu0dRuX+9rp4nXjodbqQTv7Ui7NBxA="
}, {
    "num_cand": "U2FsdGVkX1/v7zcyE5r5KKf0rzopHMv+2sn5RLEFfxw=",
    "cpf": "U2FsdGVkX1+040g2Jyu3xXRv4NYzMMXM376rVHMeloo="
}, {
    "num_cand": "U2FsdGVkX197yK0rwoggC0oIKjEUMV8a/xy5m/oRXUc=",
    "cpf": "U2FsdGVkX18kBjRF4tOs/FVciQDU92LGsGC7ny2TaS0="
}, {
    "num_cand": "U2FsdGVkX18bXwUGftNvAoJWtwtesGmO3OqgHcR6Leo=",
    "cpf": "U2FsdGVkX1/lo8L5nmBP1tov2Z0tFMYa7sMMp85GBsI="
}, {
    "num_cand": "U2FsdGVkX1/V/fOCCgTSq4Nr73mYB6G3C62f4V5XXW8=",
    "cpf": "U2FsdGVkX19K1bTKdCRQFfstmvtcjbae5dqLbyNX81w="
}, {
    "num_cand": "U2FsdGVkX1/MgamxOKqACo/CDjfcW+/b49z7z+VesIA=",
    "cpf": "U2FsdGVkX18nXVN3GBmkmlKpT62rN81ENLeXF7WFMuM="
}, {
    "num_cand": "U2FsdGVkX1+9tplc69G78+D60yuMKxpAyDrVi+i30r8=",
    "cpf": "U2FsdGVkX1888+iB389dMrMhmHgUIfisWtx0mKfM0zY="
}, {
    "num_cand": "U2FsdGVkX1/IqAU41LSZddOmHvwR80jyhuKfawWGcUg=",
    "cpf": "U2FsdGVkX1+IeHVDssxPE/ZbsJuJ8+gp+aPgkAxTYgM="
}, {
    "num_cand": "U2FsdGVkX18OB1j9F1G7boxOk8VjcsFkpCQkhabiRw0=",
    "cpf": "U2FsdGVkX183ONZ3+Ql8bLv7Amc6FD2/+Em8SVfUYTw="
}, {
    "num_cand": "U2FsdGVkX19RhOkM77Mje9/ltEysUUbXtmHIucfn6sw=",
    "cpf": "U2FsdGVkX1/u6woMFf3oEFGExQsgb5QDCWlqcQ0PtYw="
}, {
    "num_cand": "U2FsdGVkX1+J313FskZ/X74K8XyYqlM3eHJXYdg9lwo=",
    "cpf": "U2FsdGVkX19sQEkioGlMlo9Ne1OS8nhZYcpBYLHQKU0="
}, {
    "num_cand": "U2FsdGVkX1+iks2Hszllk8aGyMW/s+c46Ge7DUxyXSg=",
    "cpf": "U2FsdGVkX1/5IkO84DbH6vp41ryHtPoVZpmmD/bqlMA="
}, {
    "num_cand": "U2FsdGVkX18QUwmJ1O68jUDV6pQDVKTAbv9rVDZR81w=",
    "cpf": "U2FsdGVkX192oMCfnncS2ftNdubRqvI41afaF5UfZG4="
}, {
    "num_cand": "U2FsdGVkX1881oFcd7WKzkd7iqumqagTAzdCPxMOy1E=",
    "cpf": "U2FsdGVkX1/qtdK1FNMt4HBOH7I3joC1cA8eSKN+ho0="
}, {
    "num_cand": "U2FsdGVkX1/azeUox8HB8BTqpWmuTIyqwIqYdOfGZjM=",
    "cpf": "U2FsdGVkX18UrNh6W34rbJX+1LYfjPCuLO5+nOr8b90="
}, {
    "num_cand": "U2FsdGVkX1/z2dmCsLx2ZBBf0UjSsUJmh+5xPXglwBs=",
    "cpf": "U2FsdGVkX18dvsoQR2UDgLHCNH2tEZJpgGJeV+f2X7I="
}, {
    "num_cand": "U2FsdGVkX18vcAGuEEv9rzmhxZmotVoE6TaMlYD2D6w=",
    "cpf": "U2FsdGVkX1+ioMc88cxL1yJVwWMQyYDo/a+iJZiGA8A="
}, {
    "num_cand": "U2FsdGVkX1+1pJ8R0CeLJeIt6RdEl9hfSG4Jt+84FT8=",
    "cpf": "U2FsdGVkX19uezhNGS+vwk+Ibelsm9nlJuSLqMGLwEY="
}, {
    "num_cand": "U2FsdGVkX1+Nuz1QDPYqZ8YtI5lN0+xjpaTnkuNFiyQ=",
    "cpf": "U2FsdGVkX19WsO4EN+qyZwMWkYT6FE90l1u6wDw04YY="
}, {
    "num_cand": "U2FsdGVkX1/vnEoeZcsPfEH34cqaPp457XQFQSMKo3E=",
    "cpf": "U2FsdGVkX19otV0jqB57t3eiVLCpOJRN9bi634qOS/c="
}, {
    "num_cand": "U2FsdGVkX18h0UVrVKHdrdapHdyB/PFyL5eqKp69lwo=",
    "cpf": "U2FsdGVkX1/CcZczogg6n+lEbQcC2zK+SRv8pRzC+ic="
}, {
    "num_cand": "U2FsdGVkX19L20E9WSOAjT1pVgKmmjQD9HeyOAz9JEM=",
    "cpf": "U2FsdGVkX1+4E/2rvQKr5u+1m7uE4PUpVlVjUQ3G7H8="
}, {
    "num_cand": "U2FsdGVkX1+onrb0Sk+TyRqL/gfdXb3xOallnxUlJIY=",
    "cpf": "U2FsdGVkX1/CRC2RYLfYzj4mTh0UwNXNFpDRBCMfG+I="
}, {
    "num_cand": "U2FsdGVkX18W4YneclqO6WriaAKiT0uiftUtyJjkm9Q=",
    "cpf": "U2FsdGVkX18cS0IHkNs8AtVWQZVyk1B42Fo6+N3fMOk="
}, {
    "num_cand": "U2FsdGVkX19yZQy5kDNavxrEYJ+m0fvss53WOK8APOE=",
    "cpf": "U2FsdGVkX18qwWo/9FnHDc4IfCSDyNNDP5JYDN3a1eU="
}, {
    "num_cand": "U2FsdGVkX1/26JpwQL41N4ssGY1GM9Js5CmHPliwYU0=",
    "cpf": "U2FsdGVkX189rOalU9IjdxyTkhI5SgoK6dYBkTklhCE="
}, {
    "num_cand": "U2FsdGVkX19xCzuh4VffnndqWMPEN7SxvvGENbQnefc=",
    "cpf": "U2FsdGVkX1/HO48aS5KXTOo7G42/0At+7S1KLsie6wk="
}, {
    "num_cand": "U2FsdGVkX1+xXLGQlyVbQlBClqI+oxAR/t6neOl3aYI=",
    "cpf": "U2FsdGVkX19SYAK4dKSZT9RwnBV6lGoCod/WFxZNdEs="
}, {
    "num_cand": "U2FsdGVkX18KrJesIFOeBTny+ukEN3O3tNFf6tEYMVI=",
    "cpf": "U2FsdGVkX19XWqfytyJuJ/Dbakx8y4tEpujw+NfGwqU="
}, {
    "num_cand": "U2FsdGVkX19T1f589h5UbQ7LW8+G7yJ6EcvJSF76/u8=",
    "cpf": "U2FsdGVkX197a6tXY+Z0GFAWt/iwO0OqmuVT1a6sCKA="
}, {
    "num_cand": "U2FsdGVkX1/ziz6EimVS/TwL6+GmJv65jllWmlsj6eg=",
    "cpf": "U2FsdGVkX1872xHv6NNRGbQT5jelG+MGXbqr+Jfu6Ds="
}, {
    "num_cand": "U2FsdGVkX1/PjifnhXIeCaiV6V4TVLXv7GBII+UiXL4=",
    "cpf": "U2FsdGVkX18pU4CeicwVH986t0ZTtv1bR7oYayBdK0w="
}, {
    "num_cand": "U2FsdGVkX18bIALQqP3SdOEYsROmzLfqkwHTT8A+6qg=",
    "cpf": "U2FsdGVkX19nHCk+zf4NNwHRRbQ0PJm9u8z47Iyac04="
}, {
    "num_cand": "U2FsdGVkX1/ndrdyS7EiE/eFjP9dZmVg3VSuRsoLV1k=",
    "cpf": "U2FsdGVkX186qQ9oL8a7lHiYGxLijYcAoqDxJf8keLc="
}, {
    "num_cand": "U2FsdGVkX1/wQzxHncyBnUJ2pk976Bb1E/NHcm7SsYM=",
    "cpf": "U2FsdGVkX1+vmwEnwrfp5Y7gn/fqSTsOvZLC/vKHAUg="
}, {
    "num_cand": "U2FsdGVkX1/WEzRai6tUUaZ5TuUnyqgN8fjLtucc1OQ=",
    "cpf": "U2FsdGVkX19/GNTF0B/I/CIhvzs3q6QsmfGjTNQp4ag="
}, {
    "num_cand": "U2FsdGVkX19+7uIe4nsCzjwDH7XtlVdUHBypTRsy2fc=",
    "cpf": "U2FsdGVkX1+4hqQK5bRAsUlNdq6ewVpwaxSukcwy5Ck="
}, {
    "num_cand": "U2FsdGVkX19jyyBXvDEeYFD5OILcRwrtrakCbZyPmB8=",
    "cpf": "U2FsdGVkX1+oINliithb2HccXO/sX5d8xC4flCJRcyc="
}, {
    "num_cand": "U2FsdGVkX19D/8C8sq7+uupn8IksNvDDBjUlF84VNNM=",
    "cpf": "U2FsdGVkX1+Kmtkk6xa1r6kqj2WadW5Krm4cyoeieyU="
}, {
    "num_cand": "U2FsdGVkX1/DKM2U54xBQVTSjT7CyBcZQNjtEXXDo7A=",
    "cpf": "U2FsdGVkX19CGTnc8XVgNMNAhJ181ROmjs+P4cmlJJE="
}, {
    "num_cand": "U2FsdGVkX1+MXOIIpruCIflB3eEEK5AetJLv+75yVvk=",
    "cpf": "U2FsdGVkX1+jaJIWKwuqop5HEdPNlPI+qow4YjlF69s="
}, {
    "num_cand": "U2FsdGVkX1+GipJfomUUpEEDqnoOWRmCbp493bclD1w=",
    "cpf": "U2FsdGVkX19im7JPzQyIB1rIIXLZimZq64x+dDOBSxQ="
}, {
    "num_cand": "U2FsdGVkX19E4hXGaKVRs0u6f52GWQgsBgji2TExOy4=",
    "cpf": "U2FsdGVkX19E/YyUgbJY8Y1J8axhllnTnBDQEbZgdgo="
}, {
    "num_cand": "U2FsdGVkX1/al7M4vZVsG5zTlVPmlV8ZWrkclLpxDYw=",
    "cpf": "U2FsdGVkX18UeaHzotyZ6hwLwefZgwzSa7fyJkdXat0="
}, {
    "num_cand": "U2FsdGVkX1947TtXPU1hMvzmJbYKT16ZAW1SOos3Qks=",
    "cpf": "U2FsdGVkX19Dns8QRlNg8HIuYdothTqDyKRk8HksnlE="
}, {
    "num_cand": "U2FsdGVkX18zq0ywhVYrB/5pW1vn8gelXL+wk2iKFe4=",
    "cpf": "U2FsdGVkX1+YQZ0UEaNQyPCK6AKRnmjDkj/E8J7qpu0="
}, {
    "num_cand": "U2FsdGVkX1+6OK3qTDT14f6A2xsJXsWFufoF2a92ILo=",
    "cpf": "U2FsdGVkX19opf/ugXPTSIPtRzN74oBRBERd9EyY6x0="
}, {
    "num_cand": "U2FsdGVkX19IKa3JNACiClnkpgT7J1fQSsTd5ewVlyc=",
    "cpf": "U2FsdGVkX1/P0bJsG3qQumVaxWHw/0IjZrx0IOwVmEY="
}, {
    "num_cand": "U2FsdGVkX1/ELn9jUyEg7nQV2ylcsCBoxuRnYNlyyTQ=",
    "cpf": "U2FsdGVkX1+GE8/Kp5RUIxyQdFQEEJoV4OVYEcgqyag="
}, {
    "num_cand": "U2FsdGVkX1+cfHwAnukuhvHmf0kGQw5MqHLberKhHko=",
    "cpf": "U2FsdGVkX19y67RDHt/fnSVLR4IqpDC4O1lbrOV3Jgc="
}, {
    "num_cand": "U2FsdGVkX1/bEEalegIzHFN9EjIH2VyXI9vriflWR6k=",
    "cpf": "U2FsdGVkX18bMBPsEprxM/EJBOT8s1vh8Dqj1W3jETU="
}, {
    "num_cand": "U2FsdGVkX18E9P6mMIrN4y1kdkp9L37NDNctHJ0/ca0=",
    "cpf": "U2FsdGVkX18S1/1Sa8YM+SV7VL3oKMBca4RKDV3SLuE="
}, {
    "num_cand": "U2FsdGVkX18YFuJ3JOf0TdbdLvxTlgC3TuL2/1V/n1s=",
    "cpf": "U2FsdGVkX1/j81Imgf140Ea1PUVO40cYgHb+j5Xtg/s="
}, {
    "num_cand": "U2FsdGVkX1/FvgJHzfRqa2jK3hnnL1yU8O1QGPfpRV0=",
    "cpf": "U2FsdGVkX1/6D8WkS2Jgq2LS6LxoUFa9c8TB3Zo6Zuk="
}, {
    "num_cand": "U2FsdGVkX1/vtuUzF83GV5JnUzfdyIVUGy1u8l2WqlU=",
    "cpf": "U2FsdGVkX1/O5NTJfgu6MUlFFeVtEavV0ME7RWn9JUI="
}, {
    "num_cand": "U2FsdGVkX19FFVWCt+6IMolH0Lrs3vGZfPzhy/PaLe4=",
    "cpf": "U2FsdGVkX18MY4E2EYaF2BGgQwReNZ1OckXc1f0Av7I="
}, {
    "num_cand": "U2FsdGVkX18vGZbqWBUgxjVFdZq7GsFHWmXnO//ToqY=",
    "cpf": "U2FsdGVkX18HX43e8Pht4EAaxn8ePkGsmUA6FEoc53k="
}, {
    "num_cand": "U2FsdGVkX18JH8gNJlx0Xs3L4M0qtxWV+n+8S1VX7gc=",
    "cpf": "U2FsdGVkX1/xSy/hA+L3h3l7lej8QrD0uAFAsZV/IK8="
}, {
    "num_cand": "U2FsdGVkX18PSsjVpHvSFz4SG9VQUuCLZrwrEvf78nA=",
    "cpf": "U2FsdGVkX18bZUN+HXwCMeBl5/6ylDJPrJL0M0fCiEg="
}, {
    "num_cand": "U2FsdGVkX18zP1iL5JJSJGwjXAPTgO1UpgjxslZ2GWc=",
    "cpf": "U2FsdGVkX1+MY38f/UDQWLNC/xDT/q7xYPJBjja/M6k="
}, {
    "num_cand": "U2FsdGVkX18IBc46VQN+p2F4tS8aDdGvLuKlLvdt3eM=",
    "cpf": "U2FsdGVkX1+Glwe45P4LtQiDfxilhfub61ovbDkF4ck="
}, {
    "num_cand": "U2FsdGVkX18OAAozqUt5Cg7no8OBFDPStRvcsAhVWbg=",
    "cpf": "U2FsdGVkX19OoHwjhGEu3KL1mgHhYdRhuN+wOKvLTrU="
}, {
    "num_cand": "U2FsdGVkX18E5Clzk/xCNgFMbvgehx3kR0DKvETLDGs=",
    "cpf": "U2FsdGVkX18cpTxdH2nt+vEv24VRCEVNIcpQrj5tu0s="
}, {
    "num_cand": "U2FsdGVkX191fNiA4SkqiEWUpVHN1mUT77r3MhyrrY0=",
    "cpf": "U2FsdGVkX18x6tGm+xKMmarLc17fN04KuRmEOVbMLwY="
}, {
    "num_cand": "U2FsdGVkX18jbaszB7qlUi3ZuOX25yudm+Xr7kpZxHc=",
    "cpf": "U2FsdGVkX18dFlpVJbCT7nk+hWq2uoI40gHw7z1saIM="
}, {
    "num_cand": "U2FsdGVkX1/bCO+KsZG1kI8nd31qZYXzytZTEvO6yOg=",
    "cpf": "U2FsdGVkX18ToUwz8BwxYPqXorolH2kgvYLx9wCUO3U="
}, {
    "num_cand": "U2FsdGVkX1/1EuX/nQ1lNuD7OPkfI7EG1IeeQ6BVPa8=",
    "cpf": "U2FsdGVkX1/2k01nZpnLkDz8QzN0Z64SiYKiu4nLsU8="
}, {
    "num_cand": "U2FsdGVkX18RCWbuDFbH71qZ9kuwJ3XIzoByuWQtU8k=",
    "cpf": "U2FsdGVkX1/fo7g6aK84z9+kZmdBihXKSIgXs2m+rds="
}, {
    "num_cand": "U2FsdGVkX19X6JW/0/ceXy8AGblx9Fs341ZeDWLT3qA=",
    "cpf": "U2FsdGVkX1/Ly+2zf2Z1duPk7Q1NgRYJMVcwIvuYZWA="
}, {
    "num_cand": "U2FsdGVkX19YtA99qC45yxSX5P1ylZyRKofoNxzCpVo=",
    "cpf": "U2FsdGVkX18Y5OZ7roDeNzGSDNDHm0oyqAdrAhD4aD0="
}, {
    "num_cand": "U2FsdGVkX1+79wiCQgZw3/xqhSbvQbOJCjvTWD83UeM=",
    "cpf": "U2FsdGVkX18UHMx4Rqj2gwBpgpcjliTyLY09UUZ24U4="
}, {
    "num_cand": "U2FsdGVkX19AT1NqsEaxDDVY/H9qROhMB5Tglk8Ghek=",
    "cpf": "U2FsdGVkX19e7IunfVHsF2TgDEczVPK/YiULgDeuEPA="
}, {
    "num_cand": "U2FsdGVkX19YtTNOew5ruYiOfPPz8XksJupmgdAHHeE=",
    "cpf": "U2FsdGVkX1/v9EuCD2/LdgmRd5OneOaIElUvIrYEEjQ="
}, {
    "num_cand": "U2FsdGVkX1+FyFej3CndHmnplx0cilV3r/0lEUyHDKU=",
    "cpf": "U2FsdGVkX18hi+DbCtVlLzWsYyYjElBYtgx6GBfM8l0="
}, {
    "num_cand": "U2FsdGVkX1/cIUiz7o/Y5yUOLQu8QaFaNQEh+DnU190=",
    "cpf": "U2FsdGVkX1/KOZZE9Kn58twZUi19L9KFZmg+pBPl45o="
}, {
    "num_cand": "U2FsdGVkX189abwiciU5E/i+SBxpitO3GdN0Cg3DZxs=",
    "cpf": "U2FsdGVkX18Yf4S3Kiaj9lICSbJXM2Iy8K8qJpbCAzQ="
}, {
    "num_cand": "U2FsdGVkX19IHcnnSx9oIwfvj8ShpZlOEHKa9IPbqK8=",
    "cpf": "U2FsdGVkX18P3BzIWg0VPUlZflIzmIOTaeHCinrQgEY="
}, {
    "num_cand": "U2FsdGVkX19PeVgMAeenyuW4qQCWOnk211Gon4XXnTU=",
    "cpf": "U2FsdGVkX1/iTq/IUet9SCiZDm4wiQ1PvoUnRaHkI4g="
}, {
    "num_cand": "U2FsdGVkX1+mSbf8efjqLWRx045OlPv3kGzcAeeVapY=",
    "cpf": "U2FsdGVkX19bM2KkuLmSZvyLqweuo90aB2GIIv9b8CA="
}, {
    "num_cand": "U2FsdGVkX192IzEQTrvq8CKE0njeayP7pFYto54An5w=",
    "cpf": "U2FsdGVkX19eRzstxxhL0SetAfQ7yL4MSw9ZLZeYAfY="
}, {
    "num_cand": "U2FsdGVkX18lK8Vuq/SoZb+PKFUgtV6D5g9K89IgyWM=",
    "cpf": "U2FsdGVkX19rRK+4Ieh/oEVN6xScvrYmTUgi3vc00/4="
}, {
    "num_cand": "U2FsdGVkX1+lFYO2I7k14q/QGJfK1CVTtM5zz9Pa03w=",
    "cpf": "U2FsdGVkX1+fT3SSBJwLcQJccrvRBxGSv9vc/Lql/wo="
}, {
    "num_cand": "U2FsdGVkX19okJ/xWrfA021dMBJKRgbx4NFOYybW7ts=",
    "cpf": "U2FsdGVkX19kQ3BD7kBHFn013jBIFO/oRVridd6ya6E="
}, {
    "num_cand": "U2FsdGVkX18qbOinbJcsqjR+FYfdhvOjvDdVhddi7cw=",
    "cpf": "U2FsdGVkX198jBAzp6hlEcBX50lHWSfSuEmZUBYWv/g="
}, {
    "num_cand": "U2FsdGVkX1+ncuoBTL3fe86g6mrvVqioxz46q7ZPyHU=",
    "cpf": "U2FsdGVkX1/m5EKn7aYa08rZxXkxJvXKRCQkLf4hVWI="
}, {
    "num_cand": "U2FsdGVkX19ZNQn9g0BjjCglS77UCAkGeF5h+OB7YfY=",
    "cpf": "U2FsdGVkX1+cK//tiR3PDtxpnfocvu+UBdefx330GBI="
}, {
    "num_cand": "U2FsdGVkX1+8JHlQbowCs63rY4mBU0HmYnL/QLHhEA4=",
    "cpf": "U2FsdGVkX1/ZdeSHb5RS5IPbkj/j+7IQT3d+HyB6zbs="
}, {
    "num_cand": "U2FsdGVkX1/+y5Lt6M17ybsv0n2egivABDrW+SLqzD4=",
    "cpf": "U2FsdGVkX192bxl1AagyU2VkII+NtcJ/4s1UkTIgKP0="
}, {
    "num_cand": "U2FsdGVkX18HF2biz0qi5ljvIR3ZMgD5FLJhA4aVxn0=",
    "cpf": "U2FsdGVkX1+SNcaI4r9UL/Rt9S688xKTNu3ux6BMgb0="
}, {
    "num_cand": "U2FsdGVkX18dOG1l72dR3cCSRZxoj+SSHeDtt0TaAEs=",
    "cpf": "U2FsdGVkX1+S9Oygb4WNNAUMTw1ytBy2JVALIuU1bac="
}, {
    "num_cand": "U2FsdGVkX1+3S3CpzjtB6bzUhGQ03jsVhydl/IYUMdQ=",
    "cpf": "U2FsdGVkX1+2VFF3TeF4fOSVuLQAY0BzxhyGkgjxQOo="
}, {
    "num_cand": "U2FsdGVkX19XMlTligpVVFnD7NhLpEE505FwHTFvoBs=",
    "cpf": "U2FsdGVkX1/fTCVnuQZlXGIMPNnaT8o1e/CdYdq/yo8="
}, {
    "num_cand": "U2FsdGVkX1+XfcjZCwV6441TVzOl3JA2WE1xJF8Fasc=",
    "cpf": "U2FsdGVkX1/11RriEHhcbMN8XRc9xdTMrVzv63+8NrU="
}, {
    "num_cand": "U2FsdGVkX1/zTSA+8kdSOlDdp9DFneKYxfOjXjeoWE4=",
    "cpf": "U2FsdGVkX18K3CL8gY3DIGQdF2Q9y4PeCwMun1jUqhQ="
}, {
    "num_cand": "U2FsdGVkX1/Hq/yFBC8XIko5W1/KdJvGXz9XsssNQrE=",
    "cpf": "U2FsdGVkX1+oRd2GC82iHt5dXsvmCP1xGaUqC3btYYY="
}, {
    "num_cand": "U2FsdGVkX19RedcS00O08R/HDcZ/ZDw+m9WYX+ctkOs=",
    "cpf": "U2FsdGVkX1+mmbreVWejC/UX9uJKl04UNgPq92zy3wI="
}, {
    "num_cand": "U2FsdGVkX1/2M4CVwzx/AD3YNYKkZlgkmU+xSRFfYlg=",
    "cpf": "U2FsdGVkX18/kBrg4Ek+4OJLy4j/4Zy9GBP6eZ7+glM="
}, {
    "num_cand": "U2FsdGVkX1/CP6vkSoGdMduFE0J+3Lr11jd0B6I/Vh4=",
    "cpf": "U2FsdGVkX18lSBmaMX1aXvYw0hCtI7dnsAA7s6AXMu0="
}, {
    "num_cand": "U2FsdGVkX18z0GEcOueXGGh2cz/MLjbsPKvP8S+OWdc=",
    "cpf": "U2FsdGVkX18a7MBg6VMHFmx6sFcjnv2i/eaIPeFls3s="
}, {
    "num_cand": "U2FsdGVkX1/FZNYDZtjv9FfhNIyIdQvPwfkWlNWOJuY=",
    "cpf": "U2FsdGVkX1/KcSa8PgsmRAmP11PfBVLxjVURrbJHJGE="
}, {
    "num_cand": "U2FsdGVkX187MuoZe4mNqFwt0tamWnzLMDWiAaeoEFg=",
    "cpf": "U2FsdGVkX19xtn7BvtTs26XM9gBkA3IiVBFFBp54lVA="
}, {
    "num_cand": "U2FsdGVkX18ixuCvFvgK5JQ4hNTgW8ZydlU/MTvPMTw=",
    "cpf": "U2FsdGVkX1/Id9KzwhRFVJJEl7mKb1t4Lfsj4Nnght0="
}, {
    "num_cand": "U2FsdGVkX1/o9kkwv8L7lMJbtstWOom8G2FExXaQc9k=",
    "cpf": "U2FsdGVkX1+uCYNhCTwXYypFGkeRtFDtOjKKVLkcXJ8="
}, {
    "num_cand": "U2FsdGVkX1+jHI0WbqNTSgQJzQVQ+eUANGKV1t+tR6I=",
    "cpf": "U2FsdGVkX1+FUquRQbipm1NkRJehGQak5OxGNR12g7I="
}, {
    "num_cand": "U2FsdGVkX1/tF8WAIxF60/ZhSUPnitJEq+eSILteP4Q=",
    "cpf": "U2FsdGVkX1800ri/vCF0tvXgSbmjOnwDxbumqp3qsko="
}, {
    "num_cand": "U2FsdGVkX1/18FQk8ZMt+wEUdhuVUBnhWvHF+6QKVM8=",
    "cpf": "U2FsdGVkX19KJrLvioUroyioaRqP/gKKZBLprALN7NQ="
}, {
    "num_cand": "U2FsdGVkX1+OcKMfWUeWD+LdHLfxOn0byPcUrsrlKO8=",
    "cpf": "U2FsdGVkX1+2U5rMVZEPwJgX7oVED8PWNHyk+HCdENs="
}, {
    "num_cand": "U2FsdGVkX1/aGvxHytyEttw0oW2icIVr5YCilv9QRb0=",
    "cpf": "U2FsdGVkX1/+iigg90HQQNMcd/roRLS1Io9CaBXgAPo="
}, {
    "num_cand": "U2FsdGVkX1+zzXANjz9h9kCHPscLOB0yYSHIptnSlGc=",
    "cpf": "U2FsdGVkX19FyrCSsX5WI/b5onzIw9ta0Q9kifW4cLo="
}, {
    "num_cand": "U2FsdGVkX18iVTGFUUFM5Dr5233pnmZN2ThnlIpIwo0=",
    "cpf": "U2FsdGVkX1+SSoMB3KtiFPpZWN+v0lK4PA0IaPe0wlg="
}, {
    "num_cand": "U2FsdGVkX1++Q4vQc0h64AJbR1wsq0t5/Rv6Pb5ahTk=",
    "cpf": "U2FsdGVkX18Y2Ii3X3ko+esnGXO/NVTtFA0wE9U5+rI="
}, {
    "num_cand": "U2FsdGVkX1+mP0fHve7hXG+5IRngemG/kZblKRDzcQ4=",
    "cpf": "U2FsdGVkX18oVfRADt4Gprv0fAUIbN0c4Qhn4ERUY2k="
}, {
    "num_cand": "U2FsdGVkX1+6oEJfwOBAqbljbHnlkhyIMAIDSQrWSXs=",
    "cpf": "U2FsdGVkX19pmAVrbFvVlYwHoliWS+HBnPptIJ62xxQ="
}, {
    "num_cand": "U2FsdGVkX1+b23LPiwRHIdNiR9IeplCLPBb0BfqVXuc=",
    "cpf": "U2FsdGVkX19wkqgXQA9TzX5OYh+8TdwwuWoIzG9kVrM="
}, {
    "num_cand": "U2FsdGVkX1+trgA9bwjW6PGhoCW0rXdTHiS8zZEFsN4=",
    "cpf": "U2FsdGVkX1/eQJoMzzz9kI00UEkb1Ej+gQ1ByDNnuyY="
}, {
    "num_cand": "U2FsdGVkX1+Xpiike4AC5fkYLW84Wj5mnUSC1Rg0Tnw=",
    "cpf": "U2FsdGVkX19eUaGxPbE/47c0GYLMsRh9BDCs6rAkKvg="
}, {
    "num_cand": "U2FsdGVkX1+OhDfOtxPUYiMs7jq7/CD9wkxYjZoa1JM=",
    "cpf": "U2FsdGVkX195MGmNj489Uy3N0/otWYzFaGr48f+o2SI="
}, {
    "num_cand": "U2FsdGVkX197IMY/u2+ofQJll5hUYGmdOuZsselSmpQ=",
    "cpf": "U2FsdGVkX1+GFB86QehtLY3tTr2OnFtMPoBewyIzvj8="
}, {
    "num_cand": "U2FsdGVkX1/YhIqpHsOODhlYTZgc7t2sLUmwiDuVuDo=",
    "cpf": "U2FsdGVkX19k8h7sYwFUGSZTANCPj7pS2nUJrUZWns8="
}, {
    "num_cand": "U2FsdGVkX18Ve6BHQLDkHxgZbccUBtul6vMlnIXYIT0=",
    "cpf": "U2FsdGVkX1+kxw08UVSgVa+ZWK9T/HnakxtqV985Ccs="
}, {
    "num_cand": "U2FsdGVkX197ct/uDMgA3mQbbZXGUovEB+mZWkCR/5s=",
    "cpf": "U2FsdGVkX1/t216i+Tp9jlpedxQoCwW1SomxwsJ3/Ws="
}, {
    "num_cand": "U2FsdGVkX18s0d+Voc05Q+LY/J/5gtTrwMPNyGz3/RU=",
    "cpf": "U2FsdGVkX18b1PX37FSf2HXvV4JX6WaJvQvj/espQuM="
}, {
    "num_cand": "U2FsdGVkX19aumsPvPa+vj6inJrVK2j2P3BhrwLiDg0=",
    "cpf": "U2FsdGVkX1+ILmzN4xzYfjhs/WmtF3c5rlXF4tlsIes="
}, {
    "num_cand": "U2FsdGVkX1+SySpeF3RjTU0aiZmk9EouQd3PjL1flxU=",
    "cpf": "U2FsdGVkX1/r/10RmcTUX2fynNUik5A79hrM3G2wvw8="
}, {
    "num_cand": "U2FsdGVkX191B20mH9MGBd7klnlBRmB4M60yeYoJgxo=",
    "cpf": "U2FsdGVkX19wThGfdjN5ioLQ5IcjpT2wNLDvquvD1YA="
}, {
    "num_cand": "U2FsdGVkX1/EsHybc5tSHhJV8Q4hwCNl2FhYktKyxpg=",
    "cpf": "U2FsdGVkX19VCRc/o8jERBFqIyftmripoivYjCivH/w="
}, {
    "num_cand": "U2FsdGVkX18QV9OYMCJ+GxrbsrpUzRccBiTGdqdarfk=",
    "cpf": "U2FsdGVkX18XG97sWzncwIF8BDqEitfkeJzGku84vII="
}, {
    "num_cand": "U2FsdGVkX1/oXsaM64LEwPGUoem/p/wddnXEV7aVJKY=",
    "cpf": "U2FsdGVkX19afFFlGRSzmqbvw5jQ7EOelSyo91fLs68="
}, {
    "num_cand": "U2FsdGVkX1/9rr0CaXD9WVGdNo1uJfih1Te3pGcPKN4=",
    "cpf": "U2FsdGVkX1/1jQQzxv7vs8gnuxO4e95G2ys14Sa9JPY="
}, {
    "num_cand": "U2FsdGVkX1+YatWf7LbIHant97Sk9Q8H1y4/c1sOxo4=",
    "cpf": "U2FsdGVkX1+foXQwCIT4Fcqft72YuuLUVESvoWIkOlU="
}, {
    "num_cand": "U2FsdGVkX18COLJ+vzz5DMHX2p9hcbYGeOtMUAcRpWw=",
    "cpf": "U2FsdGVkX19jnGBKgX/fRsyqm7RncuHHFlaw7q2txj4="
}, {
    "num_cand": "U2FsdGVkX1/dlXFStvkth2MOydNLrZ+OhUQcyVqIX60=",
    "cpf": "U2FsdGVkX19cr7N2oUt3TlN/KIXO21/cOfOMcEkbwd4="
}, {
    "num_cand": "U2FsdGVkX184C+Zzy1PmAVyL8T10LN/wN3Au/GRUXkc=",
    "cpf": "U2FsdGVkX1/IW8mMvrE8IdNZ/QpXxpJsudvWNjaamYU="
}, {
    "num_cand": "U2FsdGVkX1/CZks4KXp1a5EnccqGYSUbOEKx3+akh+s=",
    "cpf": "U2FsdGVkX19tuGfQwXvO2MsOI7LAp93BLTCBG0jnzqU="
}, {
    "num_cand": "U2FsdGVkX19YlGR2n71w4dUuH6iCqHrM98ryYh2zAiQ=",
    "cpf": "U2FsdGVkX19Tagbj1Xme2AejZVGMBrockE8yxqZj1ew="
}, {
    "num_cand": "U2FsdGVkX19/gKpYSrYeXcDrbfjnjKbzuzpVjyTG6go=",
    "cpf": "U2FsdGVkX1/il13f8xqkJrnphZRPU07YQl99Or7TjTE="
}, {
    "num_cand": "U2FsdGVkX19SEfZ8H2flKTM+7mBAj3hZM45BtBfZW1Y=",
    "cpf": "U2FsdGVkX1/qO1PWoU09GhllA9eRLeJAcvjWOC0nui8="
}, {
    "num_cand": "U2FsdGVkX19xsB3+A4tueGK8n6Ehzr1xZnDDNQCdi/4=",
    "cpf": "U2FsdGVkX1/8/psovBoyAYxjLBLVlCe7McwTsathDbk="
}, {
    "num_cand": "U2FsdGVkX19G1kJiIs+XMsm+GBU5xXLdL2UqSZ8tg7w=",
    "cpf": "U2FsdGVkX1+VWs6Gj+5htmGK/0cKeDChhLr+jfGMQa4="
}, {
    "num_cand": "U2FsdGVkX19Xq5b5w21un27D4POKlOFBrZstRV5T16A=",
    "cpf": "U2FsdGVkX18w3ravGOLlFyPx5qmShkK1YPGNjMIkhU0="
}, {
    "num_cand": "U2FsdGVkX19uZHGJz8AGPFmhXKAyOtXxmjjQNN74xUQ=",
    "cpf": "U2FsdGVkX1+s1V6OXBS7/HXIlP943izoZjEp1w6ygm4="
}, {
    "num_cand": "U2FsdGVkX19JxFAD++UCsjMbrOmckQA4gF010mFIUcI=",
    "cpf": "U2FsdGVkX18NxXI7CBXDcKRRiuAyHgmi1/woN7D0Gb4="
}, {
    "num_cand": "U2FsdGVkX18xYgi7FVK9BPKcAQ4oHU8AwlQd9QNdOT8=",
    "cpf": "U2FsdGVkX1+7JCgSxqh+JgWHuWgdWhIeBtPGhncm5YU="
}, {
    "num_cand": "U2FsdGVkX185XekuuSxHkZA5rkLQc1KTYWj8quTnvNU=",
    "cpf": "U2FsdGVkX19qmpDT8N6hKg+sJDx/O9ItbrB0Ud2KvGc="
}, {
    "num_cand": "U2FsdGVkX19ZTuZtmwzk75/TNSlXDhTqG4fghQTglC4=",
    "cpf": "U2FsdGVkX1/YOSKDNxhv53CXMUl65bZPIE3y4NfhbAQ="
}, {
    "num_cand": "U2FsdGVkX1/CVCKVgKc4O3ssndsG1FP8uKjRPTLgxbw=",
    "cpf": "U2FsdGVkX1+g988AGsJRp1Pw+U9Hd6NKWrP63/v28JI="
}, {
    "num_cand": "U2FsdGVkX19UKGscPg2G/joY2PuKtlSvbOEPjxMbPNg=",
    "cpf": "U2FsdGVkX1/PmdAq8RoKlc+5A864lvBVULq4M82FW34="
}, {
    "num_cand": "U2FsdGVkX19GYAR6xazoOG3tj/jy+t/NPcH6BstqEI0=",
    "cpf": "U2FsdGVkX19jNSQTAnxpMQbMDei18s12vEEwBOtKx7w="
}, {
    "num_cand": "U2FsdGVkX18tdC2eH3MyaXB77TeJ85eWy4eFUfVK7BA=",
    "cpf": "U2FsdGVkX1+MBV5bAqRjyLHV1ADDo19bhTQdYk/85TI="
}, {
    "num_cand": "U2FsdGVkX19e9wFokiuHIE+GRpnGxKlwOgV5QsdSdho=",
    "cpf": "U2FsdGVkX1+pkyw0RC1/XPiGcTi2QykW4VeqULSLfyI="
}, {
    "num_cand": "U2FsdGVkX19Sa+7aX2MpyorKksehm0rP0B8fmKNRsQo=",
    "cpf": "U2FsdGVkX1895TKdYFMECrNvLAxysiHk1nbD9UkpQGM="
}, {
    "num_cand": "U2FsdGVkX1+0NYPhCrIAgDilMxChEjgXHUxIhOgtZRk=",
    "cpf": "U2FsdGVkX1/4H2Q4z4OGVI6xpCf5+dAjO5bsyGk9VMw="
}, {
    "num_cand": "U2FsdGVkX1+CdtKOJy2ShXOZLXE3IF6YJkMsVtgJ7QY=",
    "cpf": "U2FsdGVkX1+b/BBtzvC96/8GvGVvwaQOcFM8G1WjDXc="
}, {
    "num_cand": "U2FsdGVkX1+mlE2IGvSZFao4i400bRMqyin/rpZrVi8=",
    "cpf": "U2FsdGVkX1/reHe7dQXdeVie+n9Sxceoy/i5iWhVNCc="
}, {
    "num_cand": "U2FsdGVkX190/KS02zTEx8tNElEjpgBPLLsR7iLTYcQ=",
    "cpf": "U2FsdGVkX1+Psx/O/mgjrD0Rt+75iMj74c4xOFCERG4="
}, {
    "num_cand": "U2FsdGVkX19DAhC34N9ZZuKYfwDOu3KgGrCO07hWZWQ=",
    "cpf": "U2FsdGVkX19WUWoGUwAkgpS010+eHPZ1onvuT2Z1lzk="
}, {
    "num_cand": "U2FsdGVkX18IVTggLZUW+uSFxbhuQZ6T3ByeRjFALo8=",
    "cpf": "U2FsdGVkX19B4vP0/9NdC6xhnQ0lk4rUu+T2+NbHSSU="
}, {
    "num_cand": "U2FsdGVkX19HURxT38stLTgIEF4m0KFfWguoAIFdeHk=",
    "cpf": "U2FsdGVkX1/HIyN8rPqpBsBRO8Ko5gOkJIKVV2v7hlg="
}, {
    "num_cand": "U2FsdGVkX1+huWGnXObmEnNhalDSzOa6qkJXwIYXZVI=",
    "cpf": "U2FsdGVkX1+TLAEOkerMGv0EN3r2016Ev9ul5tbzcFA="
}, {
    "num_cand": "U2FsdGVkX18X6evZtWh1LIOnbcnMs6NOB4u1FmTFvl0=",
    "cpf": "U2FsdGVkX18DtYbB3TZ8HX3nk5T94uI2jMutI4A5+ZQ="
}, {
    "num_cand": "U2FsdGVkX1/4AenwDAe2Yfv9l2VbwQi5IBa+xpWPKN0=",
    "cpf": "U2FsdGVkX1/AH0aLkGDH15YccE7x/OHfPCseSU/O9mw="
}, {
    "num_cand": "U2FsdGVkX187GKXxftT/IJ1Ev/stTPrUwECqA7klwcM=",
    "cpf": "U2FsdGVkX1+bhjtXSIF4j/H+QNgEM29LNCsD2edIntg="
}, {
    "num_cand": "U2FsdGVkX19kmbnGv/QYqDRgaXHhJoMza5qiVMR3j9E=",
    "cpf": "U2FsdGVkX18GA+BjJL/ozvD2h4OhJ5gUYlFIv+3ehPw="
}, {
    "num_cand": "U2FsdGVkX19SFWAmNGt5xoJihGQ+SQb2vWRmqhd0bLM=",
    "cpf": "U2FsdGVkX18ffH6VN9Zz25oI4aJSQ+bpajfM7nQNPM0="
}, {
    "num_cand": "U2FsdGVkX1+QSgGACNlG76tPppRL92Y/sn+bgrSlnIQ=",
    "cpf": "U2FsdGVkX18tE/k5zHzczyDcV9cQLWg10BjBG/jWkEM="
}, {
    "num_cand": "U2FsdGVkX18grXT/kUrX6t1cMTXdOAmCc6nPGOd6lhQ=",
    "cpf": "U2FsdGVkX1/lc4MU0oCv+Mv+niS1AHvlC32N9HbGA9o="
}, {
    "num_cand": "U2FsdGVkX19nK23bvyLCYpERh1+eCLdngiDtlmyN3n0=",
    "cpf": "U2FsdGVkX1/fiBzYEV1ZWxeG3QkXIQSxaLOOXB3Hr1E="
}, {
    "num_cand": "U2FsdGVkX1+5f0IQVzxtNIp6yQ4tYVwRqgdEnBaRMfU=",
    "cpf": "U2FsdGVkX19LVX91TWXxmegFKqrpYFJk5tv5FqXKz4w="
}, {
    "num_cand": "U2FsdGVkX19+5Hr8XRK9A0owwVGUtEj8pERyHo0ONkc=",
    "cpf": "U2FsdGVkX18bfyPNyn7awP3/c0N3wKpXaYR+w2q3Lvo="
}, {
    "num_cand": "U2FsdGVkX1/Hp8eJ0whDl5+N5l9cwa2tPxgIJShp5js=",
    "cpf": "U2FsdGVkX1/ARvL7wL4kslsUzqpWlUDuZ9cKNZkxjsM="
}, {
    "num_cand": "U2FsdGVkX1+YiSenIXrsLV0Cw3fjVEgQjF+CTOghOSY=",
    "cpf": "U2FsdGVkX1+G9z0pui9wV9RwNewk8lWCBUvOEGhnBus="
}, {
    "num_cand": "U2FsdGVkX1+rJPZ0eDJFQOJu9Fk8QH3cgqrEzrubQdM=",
    "cpf": "U2FsdGVkX19Y3nmOSFHW3088mYlI6oIKg/gkp50K884="
}, {
    "num_cand": "U2FsdGVkX1872LVmfqz91LyWTShHcGhNH+xpzUykLao=",
    "cpf": "U2FsdGVkX1/BqC7UD1kzase4gex34mRgjia77kaehUg="
}, {
    "num_cand": "U2FsdGVkX19wAatRkztpyOiyvm/OtKOuqtggb7jIta8=",
    "cpf": "U2FsdGVkX19RdiA64ok/QndY5N1s9mZbt99b+o1DAWI="
}, {
    "num_cand": "U2FsdGVkX197T3Fhq7YM98k95tj6cgSkRe4mFav4Z0w=",
    "cpf": "U2FsdGVkX18gZyln8A7F7XgM49kPM7cQSG854b+V+QQ="
}, {
    "num_cand": "U2FsdGVkX1/ZHb5EpgbJgaR+3pp9/MBsgVPcTYHLog8=",
    "cpf": "U2FsdGVkX1+Ud87ct4A4xote9WMaKS5RPi9hkOcnSCE="
}, {
    "num_cand": "U2FsdGVkX18ysGSqpwHAf8qMmk8hkEE1l4fRXXv/vjc=",
    "cpf": "U2FsdGVkX1/gxeBMrUKfHS2AO8ZuqBTKCoEP05sE/Ok="
}, {
    "num_cand": "U2FsdGVkX181FvZHNoy0ameFV3Mivp9WLNKpqR9chO4=",
    "cpf": "U2FsdGVkX1/1gpCE32nRkV8fcGSdfxsxXwsX48qfrBA="
}, {
    "num_cand": "U2FsdGVkX19ELWZUsKTQu6ekDBjzycqTH2qwbrRHiZc=",
    "cpf": "U2FsdGVkX1/iyZMaxivVkoFf7t8dfLZ1UbBrst1sGMg="
}, {
    "num_cand": "U2FsdGVkX18KMhv0JSm2iF100AHqQdOPuhouiiAtA7w=",
    "cpf": "U2FsdGVkX1+tN4LGfqpX54T+AXBgFmS+VNcNRLUq6nc="
}, {
    "num_cand": "U2FsdGVkX1+7D1ogRyBcsILZ6AYeAKfwpjBPzB70HRg=",
    "cpf": "U2FsdGVkX19aciMWVqLJlqmxaCYr3sIgopEw7dHdhYk="
}, {
    "num_cand": "U2FsdGVkX1+Km8pzNvDJdalP/ckhfiVDgqw6Ord7tH8=",
    "cpf": "U2FsdGVkX1/YMygS+HoSyPQpjYMhgrNsWsIfKcdpVf8="
}, {
    "num_cand": "U2FsdGVkX1/88O4OdzTCod6pPGgR9awmLqQaybyWz8A=",
    "cpf": "U2FsdGVkX18qQcq1JMHwO5R9qptX0XC33xLA4nRedQE="
}, {
    "num_cand": "U2FsdGVkX1/QcyqEzAdGKg2KJTVL2QOENIsWo1rQOGs=",
    "cpf": "U2FsdGVkX194RYXsLYj7VpbAG+3BE8GZhj4+BKUt8bw="
}, {
    "num_cand": "U2FsdGVkX1/DmlU2kJr1I710Or/XbZGz2JvznD9dO6M=",
    "cpf": "U2FsdGVkX181WGkX209t3NKsAZQSF+z3j+iI4333dHA="
}, {
    "num_cand": "U2FsdGVkX18BYmGvGNYjXSMQ/hWHg483PYVQvmqpIiQ=",
    "cpf": "U2FsdGVkX19GovnFbjcu8wNDzn06fWG9IANP+d6HU7g="
}, {
    "num_cand": "U2FsdGVkX19th8vAj3MEdMiBsy/OFkmxuJhn1p3SHQk=",
    "cpf": "U2FsdGVkX1+D37fYzuxQTQR2Tc7EGpL44sIBGW9l5H8="
}, {
    "num_cand": "U2FsdGVkX1+bPQqMi7J+DZZpeJU9CQfhiIQ2amxS3TE=",
    "cpf": "U2FsdGVkX1+Rx9WC183SS9YHdoybvXZKNW6Xu8ug8G4="
}, {
    "num_cand": "U2FsdGVkX1/4qtXBEK24eeVEhnvlmDcZ8mWlZH62qVw=",
    "cpf": "U2FsdGVkX1/mFKXy16zklb9BwpC3EZHYKmbe2Bpzz8M="
}, {
    "num_cand": "U2FsdGVkX1/Xww+sI51iUnOUCvB2zvNkgGpvqRfB1Rc=",
    "cpf": "U2FsdGVkX1/StH6fuVkqkZtgZn5oMr8cSDC2D4SQUMg="
}, {
    "num_cand": "U2FsdGVkX18pn4wQbTuia5EvPdi1wIUGyTAjt9C23Wk=",
    "cpf": "U2FsdGVkX18BjmlmVCCewl6Ni1epGE+t2CxSDhmLqZ0="
}, {
    "num_cand": "U2FsdGVkX195YPxrQ9GCLT0iN7SlpUMHD3Ia56jydTI=",
    "cpf": "U2FsdGVkX19+GBXxXHK1DY0CNddsOyhU0AhHLvVH/ag="
}, {
    "num_cand": "U2FsdGVkX1+wdrO4k+xUQAFivco41HVepJA+Ein6Wz4=",
    "cpf": "U2FsdGVkX1/XxP6+umBLC+UHhQTyX1w2nMJy/tWOL54="
}, {
    "num_cand": "U2FsdGVkX19ojWEj/nc283GEG2XlWDkkkMpqzZxOM2I=",
    "cpf": "U2FsdGVkX18hzTsLrruGEyPQGHaANGLb4RrZekYdheI="
}, {
    "num_cand": "U2FsdGVkX1/7qcG9C8YfWB+uirJsn8d48n1ZwbO78XY=",
    "cpf": "U2FsdGVkX18lJ8k9jy19uKyozvI25ZMAl30suQZtK7A="
}, {
    "num_cand": "U2FsdGVkX1+TFh0LVJpDa2vULHE3FJ0tjJxIojKqFTw=",
    "cpf": "U2FsdGVkX1/nlToVwLApYV4FHP/wEnLeAvKbiK/v4Ng="
}, {
    "num_cand": "U2FsdGVkX18uDpsE9kvXeRqoFES2MPIJ0pJb/lcIu7g=",
    "cpf": "U2FsdGVkX19biAj7jIPgoMXrnxTYa1qoCxNM5cPGuHA="
}, {
    "num_cand": "U2FsdGVkX19LOPlLmZDEmIxBZxcUBgXyJkOZUXiF5LU=",
    "cpf": "U2FsdGVkX18kt22wZdyv2upjT2bweG3hyjMj6JjWE5E="
}, {
    "num_cand": "U2FsdGVkX19OI9GKtP/qajOBEqk5L8z6arY7qTxs7JI=",
    "cpf": "U2FsdGVkX1/VpktPLdvrFk+euJF72ynHTO2cBB/sz+Q="
}, {
    "num_cand": "U2FsdGVkX1/rGKxKBCWIMQx+AmvfEJyPvIbpJ6007eg=",
    "cpf": "U2FsdGVkX18jkJGvip5PwLtUpDeD3y/igUcMZQDPgWE="
}, {
    "num_cand": "U2FsdGVkX197z8yMLqK/hazulWih85O3zYtuOR28sQg=",
    "cpf": "U2FsdGVkX18fyU+IaLtnKJYr6d9VtsnxTZs7knbYOAQ="
}, {
    "num_cand": "U2FsdGVkX18ZWeTPD2jYW+6bx7h8Xa/ULCYR8naCxfk=",
    "cpf": "U2FsdGVkX1/EZkqzfobjFAMOPa1z/TwOx4OLriRq4og="
}, {
    "num_cand": "U2FsdGVkX1/xd2TwP8ZTyNxHxwSm+OyZ109jXD383lM=",
    "cpf": "U2FsdGVkX1+EKwIX+BYkPKrUIteqk34XWDpkQTHWDD4="
}, {
    "num_cand": "U2FsdGVkX1+OlkJI+7H9TDXnVflEtQWUFdK5hSNkLhw=",
    "cpf": "U2FsdGVkX1+2nljC06i4ukxwxpHJy3EpmIdPmSFqO24="
}, {
    "num_cand": "U2FsdGVkX1/MT9i2Bqo06hEDCafsmMd48IoEzviMj1I=",
    "cpf": "U2FsdGVkX191Q42XLmmYcjEIHYBw8QzulzyxaeKK4t8="
}, {
    "num_cand": "U2FsdGVkX1/qV6+nemkhn426dSsjYxM2mTsRrb0fRk0=",
    "cpf": "U2FsdGVkX19UZ6XsadjyEtS8hhnRYuApyRpYOZX2R4M="
}, {
    "num_cand": "U2FsdGVkX1/J4ccheelcHeR6JANIg04OeVSfGfgfXvU=",
    "cpf": "U2FsdGVkX18vB/PNXWc5F+4/XypP2oc93S28U+X6iBA="
}, {
    "num_cand": "U2FsdGVkX1+mUEpwGwBvb4657n4nLAt7E7a7hvjzCVQ=",
    "cpf": "U2FsdGVkX19i/4fzj3K4EAe/Z79ymMVmwwSvt0PtwVE="
}, {
    "num_cand": "U2FsdGVkX1+YV4kx3grjTRzlHPMcpZh8/XKmEU+JgIs=",
    "cpf": "U2FsdGVkX1+sFbJGn0TxgvTajST3LG4hkgJ4z/Ych4k="
}, {
    "num_cand": "U2FsdGVkX19ezWQZoZK4BF8XtwCztRlywT/64/BvnaM=",
    "cpf": "U2FsdGVkX1+PmdRm+50o09YYu05iGDwS9y+PXPupSNs="
}, {
    "num_cand": "U2FsdGVkX18Ci9Zs95FefynFMQ00itF4uvz2PnrzFrM=",
    "cpf": "U2FsdGVkX1/dqo/L9rBT2AoakZ7r7P1HqwD3bs19P5g="
}, {
    "num_cand": "U2FsdGVkX1+PV0doTH0Qu1AQHgeSDhOAlGGDhnwgKk0=",
    "cpf": "U2FsdGVkX1+jIfhkmDGQFQYnYims8VxviFyGCnuzyV0="
}, {
    "num_cand": "U2FsdGVkX182EbbPa50TM2RggfUeWviIica1lq8BIh0=",
    "cpf": "U2FsdGVkX18qOoIsaH7jx6KbK3hP4p4UGvIrJ+r2dIs="
}, {
    "num_cand": "U2FsdGVkX18gBIAvJSIOYN7Fq8QPuoXb8EgutpD+sUQ=",
    "cpf": "U2FsdGVkX1+NzvJ6o/XUW0/GVElsLtRfhPewrXuotI8="
}, {
    "num_cand": "U2FsdGVkX1+biCI7aWi4VALrx3mTW1J1sJVg6xHKXDQ=",
    "cpf": "U2FsdGVkX1/DLQ6IqBIincOWmY2ddZrdsm7Xce/wCcg="
}, {
    "num_cand": "U2FsdGVkX18RyIbDdeoN1PtWuub14gw/EFsHL8Tdie8=",
    "cpf": "U2FsdGVkX19/Gl7AlAKs5j0RxAfTWeSCuZ6CHC+g3Jg="
}, {
    "num_cand": "U2FsdGVkX19xV8nSIfIOfroJnUX+D9fG4ISpG5YAhR0=",
    "cpf": "U2FsdGVkX19GbkIZDfvIsowFdi6HduaxXrzj7vMUWSg="
}, {
    "num_cand": "U2FsdGVkX18M7NMdnsfRLobu+3McGAnmBD3d4iEjQpI=",
    "cpf": "U2FsdGVkX19nTgXMbQyzRN9ZYsuVO4bw+H8EhOYSZeQ="
}, {
    "num_cand": "U2FsdGVkX1++lwd3+Yw2qVTFax26nCSVliv6XdQgn9Q=",
    "cpf": "U2FsdGVkX1+LeoiUXai5YgMSoawIelPC/cHhjKTHcWo="
}, {
    "num_cand": "U2FsdGVkX18xfhPt7VXYRFxVtY9fkmwG/UQsHBGpKzg=",
    "cpf": "U2FsdGVkX1+YT/OufeL1dvtmHvUesKltXWZIaldihvI="
}, {
    "num_cand": "U2FsdGVkX192D1C+IdNP7/75jQydgNOwFXlZFJTOD5g=",
    "cpf": "U2FsdGVkX1/S8PNV++GlWBNXvg5Qsj6lK7KkYE84hVk="
}, {
    "num_cand": "U2FsdGVkX1+vsmJktYBn7CCylxy6tORAoZRjecu5REo=",
    "cpf": "U2FsdGVkX1/QEoE3+NpgNlHstaJaxXTri8cuDtRbQE0="
}, {
    "num_cand": "U2FsdGVkX1/RP7eDey4mL1O+ccpJsB0taH4sCRqiO6Y=",
    "cpf": "U2FsdGVkX1/2lhzGpQv/B6DdJ87iwZKl86hjikKp0Lw="
}, {
    "num_cand": "U2FsdGVkX18i4OpM2WoXjKpc6l8w3DoHDg5daPeuzMw=",
    "cpf": "U2FsdGVkX1+QntWL7tDrg9tnZgL5/omo8jXiLQom6kE="
}, {
    "num_cand": "U2FsdGVkX187Zc44E4KMFZb+ZqfMr557aMqwZf74sMw=",
    "cpf": "U2FsdGVkX1/GqcCc9h9b5AcHa+8TywTgsFnaM1GH+2k="
}, {
    "num_cand": "U2FsdGVkX18FgJOdgXDFtmTZVmyTX7N3F0MjhhuT6u8=",
    "cpf": "U2FsdGVkX1/wG1ocn2B2EYxr2gXQXCt14EpPpAjpLSY="
}, {
    "num_cand": "U2FsdGVkX18wIG8ctYNk+hoRh4WHaYatmAs9RZO7EAo=",
    "cpf": "U2FsdGVkX1+8yVJ8iwxWBr0hplC9sq3VPHQx7KSPatw="
}, {
    "num_cand": "U2FsdGVkX19rwfy70QPrCe3NTr5P7QHzH/tHhHi8Ctw=",
    "cpf": "U2FsdGVkX18ykFV5EfUx4Ig2ix2ISs1gMqIJUwCEg2Q="
}, {
    "num_cand": "U2FsdGVkX1+ZVb6vxn2vBBhmV1WCfKRhiRAfGDFqzsg=",
    "cpf": "U2FsdGVkX18HDlNsDz/KE8OAJQGA2ZCmX2bPVcBy2SQ="
}, {
    "num_cand": "U2FsdGVkX18vMR4OdPd+gXfbBHC/eRvI9MKdXvyiqUM=",
    "cpf": "U2FsdGVkX1//9Pyy4Msxamx+E32AGRMC9FXGNSU+7EA="
}, {
    "num_cand": "U2FsdGVkX18b1gakIw+JZ5pdUoOU40TSMDYwNRUjhrc=",
    "cpf": "U2FsdGVkX18WOkWLDXCrsAzruOqtXAJgNcQJXfh4FvQ="
}, {
    "num_cand": "U2FsdGVkX19/VvVloO8lRcSqsIzktKSVB9/IzHuLz8k=",
    "cpf": "U2FsdGVkX1+NLfAyJK9bvtMPtnbsV+Vbru6mNbDrlFU="
}, {
    "num_cand": "U2FsdGVkX1+v/Hw3GIbBbnEOMSNFh2d+ViBBDMHbjDA=",
    "cpf": "U2FsdGVkX19K57ZDCjSshjgGTSrnfHzqR2h6lCzBV/I="
}, {
    "num_cand": "U2FsdGVkX19ALxsbX2eN29HuWiNUZXKVy7tUMlnyb/w=",
    "cpf": "U2FsdGVkX1/b9Voxo38Hl1RlYF/LfqyIezWAdsUmVc4="
}, {
    "num_cand": "U2FsdGVkX1+ZQ9rqMXbpesedp1pYY0EwOCpPl80/yMY=",
    "cpf": "U2FsdGVkX1946AeOzSYTSK1lz60dtFH2+w1xVJM7lOY="
}, {
    "num_cand": "U2FsdGVkX1+lsA0w4HD73y9eSh3vy4qbRIsBstnrL0Y=",
    "cpf": "U2FsdGVkX1/79eKuDPEACO24W76OlSQQ/0fXz3aLTso="
}, {
    "num_cand": "U2FsdGVkX18zaZBPGe3ARkpatQkALa5eNrEpNl/qTJ8=",
    "cpf": "U2FsdGVkX1+xTkVXzi+74CTjAi+RQlmKAq7cVfGq9rY="
}, {
    "num_cand": "U2FsdGVkX1+do7JbsS6bjWMkhChOL1EIMXrUW4y5Fj4=",
    "cpf": "U2FsdGVkX18qFNW+8uSxg8gyiU2dJmVEjxNeswRnAuY="
}, {
    "num_cand": "U2FsdGVkX19197/j6g6PQYciyT7jSoZB/mFjq2ZRcL0=",
    "cpf": "U2FsdGVkX19aFLVo3Rwtbw3HY0Ku/YDmD4hXVLodOow="
}, {
    "num_cand": "U2FsdGVkX19q4PqpQKU2Qu/zpM68lu0++uKUmuEWBJ4=",
    "cpf": "U2FsdGVkX1+ok91aUS7WdXI3onRjt5Z31pftergjjyM="
}, {
    "num_cand": "U2FsdGVkX18HwCAa3fF7ArIP0BCXx0a5oNMJinecQIE=",
    "cpf": "U2FsdGVkX1+M7N1t7pGZS9kbE1exfk1hWqlRkCQMlmk="
}, {
    "num_cand": "U2FsdGVkX18GmPYt5RPNF/JKOe+47CI8DlenOODc5H0=",
    "cpf": "U2FsdGVkX1/Y67ZmWk9ZfMtuRfOr5EnkDDFtADv4juY="
}, {
    "num_cand": "U2FsdGVkX194JvBW+L5FbrYNzB5ZgeHplD5N6peFxsQ=",
    "cpf": "U2FsdGVkX19PAi5yLuYYcvZy59mDSQLm4r6F/ekDKGY="
}, {
    "num_cand": "U2FsdGVkX1+bIYa/0KJR1Ps94aLMAtvD2hvTyYDrW1I=",
    "cpf": "U2FsdGVkX1+aXKqucuLcAvE/xba7my6RIh0qc8wl0kA="
}, {
    "num_cand": "U2FsdGVkX19Ajb3gtvVOjyEi5gL+lBSUG3xiVorOUew=",
    "cpf": "U2FsdGVkX19ct6CCNPvSf5k4zgd5Rr4fkDfdOVcM7IY="
}, {
    "num_cand": "U2FsdGVkX18bsFl8sImk7q7s0hAAoV+DHxoIeAVlot0=",
    "cpf": "U2FsdGVkX1/5+JY4IsmXtGspZT45A184cTklYXrV/v4="
}, {
    "num_cand": "U2FsdGVkX1/L40a6gHmRE5JHiGsfx7dKfHlYNLQLgqA=",
    "cpf": "U2FsdGVkX19jT2EYZpC1w6VM7ZH7MMCcY5u9OKBGTxw="
}, {
    "num_cand": "U2FsdGVkX18T6O01P+pfL5SgHN7YhtFbjWkPy5K/rhg=",
    "cpf": "U2FsdGVkX1+L0EdstEqxPZJ0Acw273NrYm1GF/tMQME="
}, {
    "num_cand": "U2FsdGVkX192s6dgt4M90ypQYGzabW22dtQDwU84V4M=",
    "cpf": "U2FsdGVkX1+4Cc2syrM62KD09q0Q3asNMSFxz/uuR4M="
}, {
    "num_cand": "U2FsdGVkX18s70lgdt/JHwfjWTvbzEORk1SVQRlBa8w=",
    "cpf": "U2FsdGVkX18hhvQqGq3/3FQlb731Tet7CLtMNXeZgHs="
}, {
    "num_cand": "U2FsdGVkX196C8toCCjzK4q6Xum1qSzallup8WCfJHs=",
    "cpf": "U2FsdGVkX19KOpbAgQEd2ohG3H2iib0BD0mpi8eUW+E="
}, {
    "num_cand": "U2FsdGVkX198iUkP9mCxzB4D/v33kc/14q7mPMQNmoo=",
    "cpf": "U2FsdGVkX1+EvTNGuCqsLWg2oR1iPFE69oZdKwnStMw="
}, {
    "num_cand": "U2FsdGVkX185x1vcuASFFOrs1yDNJIoqNziWqe9Sh9Q=",
    "cpf": "U2FsdGVkX1/L1WgJfkczBm+s095buDany/lvR4plGx8="
}, {
    "num_cand": "U2FsdGVkX1/X1Nwx6jUEWfAx5t0IKoHJAmRoBLDnLqw=",
    "cpf": "U2FsdGVkX19MLGijdSuoWKGdQsSMSR1/uz88AAEwpOk="
}, {
    "num_cand": "U2FsdGVkX1+QCeTlH63CqpIm1NxkIo3S1CnyFxVAeBM=",
    "cpf": "U2FsdGVkX1+IZJFPQPxZrBxc2UAgbaZIRMlSoo8LQNg="
}, {
    "num_cand": "U2FsdGVkX1+BWUm9fj1TDzfbZEawrytvFgb6o5lmVpw=",
    "cpf": "U2FsdGVkX18wSWu7t3uvTdZOdJUM6s9yorpglcw6BI8="
}, {
    "num_cand": "U2FsdGVkX19lb5HpAK9RvdRI0bDA7hAxdj9LQlfX5I0=",
    "cpf": "U2FsdGVkX1/hgkqNWOnXETcVEhzNM6HRvIdrENQp3aY="
}, {
    "num_cand": "U2FsdGVkX1/RL89ZibwTxwkLPNMnKbkzWvrNpgoCXBA=",
    "cpf": "U2FsdGVkX19NFgGA3PxXw+3MNAiyVkTKJoJi6B4e8Os="
}, {
    "num_cand": "U2FsdGVkX1+T+v6NmRlUVQYTMAvPVMfMsWddl4ZkVIA=",
    "cpf": "U2FsdGVkX19+G/Ka3BLJ2dQtfcXPNPDPPV7977vgiz0="
}, {
    "num_cand": "U2FsdGVkX19ClnHaAGfCCtaRXYBu2M0EjUPC2EEgV9Q=",
    "cpf": "U2FsdGVkX1/mMjuhb4IEEDd372s50hQ+8xoyGxJn63k="
}, {
    "num_cand": "U2FsdGVkX1/Ir9bS1z1RT4i6bkyV18JzUsC1SoVVHlA=",
    "cpf": "U2FsdGVkX18L56xG1s2KEfqq8SzHwZT9S6dD/hQajhg="
}, {
    "num_cand": "U2FsdGVkX1+vS2DBeL9Q5V066kRRGFFLF7D8tLYGuBA=",
    "cpf": "U2FsdGVkX18oz0zNJBDSzblVp5lDTdtmYsYgukP6s2I="
}, {
    "num_cand": "U2FsdGVkX19YS48sUonOS9JuyVPVPXnAMBnlRmQAU40=",
    "cpf": "U2FsdGVkX18Yv6Vt8R0WojB0LfktVVlVWSlG21XHKiI="
}, {
    "num_cand": "U2FsdGVkX19E1M3VkFu8fJYPqRti5KGWjMs98BlXmaI=",
    "cpf": "U2FsdGVkX1/7XyixtEXN9ikj1CgQk1I0tUOwAkS5BMk="
}, {
    "num_cand": "U2FsdGVkX1/TASydbBae9thUhtpKlGa5m+j4r4YfXOY=",
    "cpf": "U2FsdGVkX1/7l++Ix5FRiN2ANBNTcjQkjoVLhzwUKyw="
}, {
    "num_cand": "U2FsdGVkX19uWwhqQOFd5NspLkTgjBWZ7eS4iG6vxzs=",
    "cpf": "U2FsdGVkX1/Plo1QLF4geue6KRz8FAo5hdnWmV25D20="
}, {
    "num_cand": "U2FsdGVkX19wlUHcfxRx4ERB56049XUKiFbN0gsSmwA=",
    "cpf": "U2FsdGVkX19MR+KOg71kcsx8Mm6J0FwDtZxNWEuCbAU="
}, {
    "num_cand": "U2FsdGVkX1+vtK3TBYBCrOH6QXXU2Ya2h+J0o/ghZP0=",
    "cpf": "U2FsdGVkX18H7v3LDSLCqS0UCT5Ke4zaPAGIlSf3nDY="
}, {
    "num_cand": "U2FsdGVkX1869ndoyruZvVLR/H/q1prf5kWq0tciAPg=",
    "cpf": "U2FsdGVkX19u1bN0Z8HjexqOPJrqrzXzWYWen1UuGPA="
}, {
    "num_cand": "U2FsdGVkX1/Mzmt0Uez6+SyZ9ETr2mjrnzVsIA5ZiNs=",
    "cpf": "U2FsdGVkX19HtYKCI0oEgmIhMhxWP2KEarK+T86uxD4="
}, {
    "num_cand": "U2FsdGVkX1+aof2xtbcnC2vLgMfzxsiXO79awVhMgV0=",
    "cpf": "U2FsdGVkX1+w/nhYh/tWr9sETS99EcsRMVshMR6Ns4g="
}, {
    "num_cand": "U2FsdGVkX193esLM0/Lt4oifUP7kFGfH37iionvZjYA=",
    "cpf": "U2FsdGVkX1/keutGuj71KG04rnhuUFEZopUgsBHWoRg="
}, {
    "num_cand": "U2FsdGVkX18npcAjX9uyFrnV35gnXdBSay36/Dbq1sA=",
    "cpf": "U2FsdGVkX18W/6u+hgDj7AGRSTyTw+TG1+REdFt6fuw="
}, {
    "num_cand": "U2FsdGVkX1/GTs44JrbooYnUbnFAXEFkCN9IgWoh02w=",
    "cpf": "U2FsdGVkX19OY2iYmNGfnEYwq4DpPYcLiF4Nivr+npk="
}, {
    "num_cand": "U2FsdGVkX1+sfMYha8MLSNkkdJ7TJgvBJ4tbW34DV3c=",
    "cpf": "U2FsdGVkX18DZDRVJaOGMlEfS146TzCocir7PJwnUQ4="
}, {
    "num_cand": "U2FsdGVkX189EgvdVzxHiIip1MvWdfaSCjr15jh6Dr4=",
    "cpf": "U2FsdGVkX180ZBwdHIA7GIi3MuEougZlpwVKBuMuokA="
}, {
    "num_cand": "U2FsdGVkX1/dtDrZut65J09RNwd+/bLFy9DT6qZEOGo=",
    "cpf": "U2FsdGVkX18Cp5FSN9WraxcRCmqfjhBa8UN9U3uvnA4="
}, {
    "num_cand": "U2FsdGVkX18wmPOPfvaKXGVchAmxGVIVuoD1cOotTAM=",
    "cpf": "U2FsdGVkX1837aVPvX/lkKW8ISRXkdx+DbbSFkRkZRo="
}, {
    "num_cand": "U2FsdGVkX1/eeGGDuhbhzKi5doMvHShl+mEyzZbiwMQ=",
    "cpf": "U2FsdGVkX18JN8HO/Xg4pt4KBvgkd0EXd3M4uD0geEk="
}, {
    "num_cand": "U2FsdGVkX18y/MJMtNz1SQ+XvIfykCZJYY/cJnFfez0=",
    "cpf": "U2FsdGVkX19+RW9yiUXky370hHlLpjzi0JTmtjqGHLE="
}, {
    "num_cand": "U2FsdGVkX1/wX4+n1BnkAW2KwZgHP+XFiamhFHghveM=",
    "cpf": "U2FsdGVkX1+TS2AgPx/IJhbjQqIBAKRz86VXEkAE11k="
}, {
    "num_cand": "U2FsdGVkX18rQfzDiKxv9wwZbUEU7lfpzh/zVXg5gX0=",
    "cpf": "U2FsdGVkX1/UpWV9lIERTczmZMrE98/u5LzVPlkqy/A="
}, {
    "num_cand": "U2FsdGVkX1+6kIMvtYW0UW4enzjoIITLIwUgrE8P6Ps=",
    "cpf": "U2FsdGVkX1/9sejqh4wJGrarD16YsztMjp7gFZHKOo8="
}, {
    "num_cand": "U2FsdGVkX18nev2IBSQ+Vswm2kt8Et9Vcp4ufTR1GpY=",
    "cpf": "U2FsdGVkX1+S0vFcgqkFygxa+aFeNpXHFg+6uSh8EtE="
}, {
    "num_cand": "U2FsdGVkX1+QXQbFEgHG4jEyN9JHRo+aLCVm7pM1Xgs=",
    "cpf": "U2FsdGVkX19xz3Dnz23gI1C9I1gSrPiFIeCs/PdZ0RY="
}, {
    "num_cand": "U2FsdGVkX1+rWt2Fh4zyuI3gLNOJTiNYQpMQLBwrUyk=",
    "cpf": "U2FsdGVkX1/NPjUwyR2XGaP19QLtRhjyM9zXw1z3zeU="
}, {
    "num_cand": "U2FsdGVkX19IWzZiYzVOEkEO+jgImaowClIrjAFTLtM=",
    "cpf": "U2FsdGVkX1/EzDhErv+GoiaHMK/p89eGQApAyCcamlQ="
}, {
    "num_cand": "U2FsdGVkX18eYjzvxlHc6BIb7fP/aScjf4rzgA1D9nk=",
    "cpf": "U2FsdGVkX1/rzIaVxJTdFNMFgY4mLUXzZ0zyHw85hm8="
}, {
    "num_cand": "U2FsdGVkX19tiApDjmZ/H8NzirBif8vNAx6MLW1b+LQ=",
    "cpf": "U2FsdGVkX19wlNrDbbqfHjF2ds89Tr+SqBhsiwPJR7A="
}, {
    "num_cand": "U2FsdGVkX191sGyDTcdmuSSENUWHWjV7mcNuVUAwySU=",
    "cpf": "U2FsdGVkX1/5f1Pi7AP+xd+gqTQGRL3jK/cEcbIRego="
}, {
    "num_cand": "U2FsdGVkX1+7wWcDo7QM9+y9Ccra/z7nG01RS2/rloc=",
    "cpf": "U2FsdGVkX19QxxaWqEyMlFo5wflc5QuyfgLfJL/09E4="
}, {
    "num_cand": "U2FsdGVkX1+8Ltfgn/e6I9eIPAF2OYXl1XzBidhA8vg=",
    "cpf": "U2FsdGVkX1+2orv7jLWZpC0ceOpf7agze//voEZXo5Y="
}, {
    "num_cand": "U2FsdGVkX1+HdqhII1M2M+MzgGCMcaii1fpXtZSOG5E=",
    "cpf": "U2FsdGVkX1/qtQljuKE2oS6qJq+fdPRFSJ7898feHD0="
}, {
    "num_cand": "U2FsdGVkX19v2orOEIN2Hd5pxg0SkjrMex1VTELQQHc=",
    "cpf": "U2FsdGVkX1/7ys2I0oKIVuAyqh15vezV95JiFDWDscQ="
}, {
    "num_cand": "U2FsdGVkX18vTheAZwS0SY13U6vGTwQvA7ZxcZlAumI=",
    "cpf": "U2FsdGVkX1+cGA6lzcJurQx4P9Em+y86AaX/17iGTsE="
}, {
    "num_cand": "U2FsdGVkX19eSGL/3Wgm+ld6wu4O7YaoJPdR2TOF/P0=",
    "cpf": "U2FsdGVkX18JxK9km9iJZnQL3sKuMgPRfc31ZDAvPPU="
}, {
    "num_cand": "U2FsdGVkX1/PgPlhO/quwiT1QMablITCWUFTo41VcHU=",
    "cpf": "U2FsdGVkX1/AuAlrzFr69G6L/QAwA0X4I20IHHyNuS4="
}, {
    "num_cand": "U2FsdGVkX19QCws8Q2Tdyhd/v9mNhIVyi0MM+xcdwgM=",
    "cpf": "U2FsdGVkX1/yiVR3RFivKCQc1iE/MQsC6ZDB39fdDaE="
}, {
    "num_cand": "U2FsdGVkX19hDIfstY1WeUvicanjFF/XEclnSpVYkRM=",
    "cpf": "U2FsdGVkX18W8vn5WgWmnQNLA8GhzhA8N9KXx4rfOjw="
}, {
    "num_cand": "U2FsdGVkX19S7m2zhnebyZekfAXjopcsUCWsfdxeYCk=",
    "cpf": "U2FsdGVkX1/s/cm3ruVtWzq4pqm15YsEKRcLM761+a4="
}, {
    "num_cand": "U2FsdGVkX1/wpOyKDe8Zr0vZNr1blhK8zztZk9hpaeA=",
    "cpf": "U2FsdGVkX19mptyYs2QOPxgEYrQ/vhUBGA/5YsUT7b4="
}, {
    "num_cand": "U2FsdGVkX1+0Lh3S0mP21asxf1cmSFEB+M6g4IOMVBk=",
    "cpf": "U2FsdGVkX1+5QDdH4rukiY/e9X/KxO2eXYg1UEGpkSo="
}, {
    "num_cand": "U2FsdGVkX18+gL4/zKKEV2gJYZu/LOV4wZDf+RwR/w0=",
    "cpf": "U2FsdGVkX19qqJWbj9JJGRRcvKXI7H44ygcxPRSgUC4="
}, {
    "num_cand": "U2FsdGVkX18bLJy68nST6AXN64w5zULS0ufuTerUdnw=",
    "cpf": "U2FsdGVkX1+doywQ3dB04MbBB6U9zcdbOZAwUT6yhFQ="
}, {
    "num_cand": "U2FsdGVkX1+SNC8ca08vmoapI8pl4siIYA+buGXXbTY=",
    "cpf": "U2FsdGVkX18JmNnm8HNr+hrqVrT8ZPaQ5Kx2LXDxs8c="
}, {
    "num_cand": "U2FsdGVkX18YnmR3z+ezqPcCoG9p5HhklCTzMj2iUek=",
    "cpf": "U2FsdGVkX18ILtPlAo+W3AqZmXMZmsF8PPaa3RYi3Xo="
}, {
    "num_cand": "U2FsdGVkX19RhgNlRQ8fXLh6I8s3QBedHx1w7ACZbYA=",
    "cpf": "U2FsdGVkX1/ldCkqdvDeW6btvVRZH1x9QdRIbpRti2k="
}, {
    "num_cand": "U2FsdGVkX1/zrT0uu2FO5xc05OxU/WMcwGNLlEXmPEQ=",
    "cpf": "U2FsdGVkX19+Wy7zLXA5ptXSQwdrYGEDEduJiDn4bZk="
}, {
    "num_cand": "U2FsdGVkX1+tsnjR23J1n7iZ25O9VN4R/TJp4j3oxmQ=",
    "cpf": "U2FsdGVkX1+6KtmPlguFxmcsQ1h+y/h15MqYP3k7t0I="
}, {
    "num_cand": "U2FsdGVkX18d2HVgHnxhvUbSobVALXxoQ0JfrSt/DXc=",
    "cpf": "U2FsdGVkX18upZtwLqDVsKs+7M1iY9Ys/ddZdAftiHo="
}, {
    "num_cand": "U2FsdGVkX18Dl5fww3d4FSVJAimq/qn2PoHPyYKtoYI=",
    "cpf": "U2FsdGVkX19BqyjJs28u5JK8/nOiDroXdpfPBTnfo/k="
}, {
    "num_cand": "U2FsdGVkX1+HU7JGIkNKvaoK7IlWhz69GEyGYHFjBPA=",
    "cpf": "U2FsdGVkX18lF0fy8+rfFncrfXFWOozNMegwA9U3AG0="
}, {
    "num_cand": "U2FsdGVkX18rD2SpXDZdu09+fzdTsLot0utNvl882uo=",
    "cpf": "U2FsdGVkX18bncjrufqoG/Bf3pP/YaLQ7vnudO42mRA="
}, {
    "num_cand": "U2FsdGVkX1+qJ54FCfsSwExMSWG7VEy9uWbymM/XQZs=",
    "cpf": "U2FsdGVkX18RhpTycmYeeY8+TJ7yjx54tJSCYWqQ46E="
}, {
    "num_cand": "U2FsdGVkX1/hhoiH79BUJ/AdPPyB76oqT/THr5nS990=",
    "cpf": "U2FsdGVkX1+cDsPr8W3HEhGvXDJdAGWp7HNCGIR+O24="
}, {
    "num_cand": "U2FsdGVkX1/vi0N/1iprVlRkTtbcxOFWXaQwNrwUQFY=",
    "cpf": "U2FsdGVkX1/fVpVkluO4puBWtkGpzBIzsBxU3gXDHeM="
}, {
    "num_cand": "U2FsdGVkX1+VAdVhHgp25dFWFz9T9WfwTZ8nwfwd+uQ=",
    "cpf": "U2FsdGVkX19KmhgwJsmnT+d3QF+wrYIaN/i70ZQMLVQ="
}, {
    "num_cand": "U2FsdGVkX19d4FQuK5dKwQw1J7LUpDmC6rwZRYt+ZS8=",
    "cpf": "U2FsdGVkX18VgRd5/73Cpr8eiKwoyIL8UgBSioXGzxg="
}, {
    "num_cand": "U2FsdGVkX185K3UIFnOGaaD+EF+VgwHAO/fmDJXQGHQ=",
    "cpf": "U2FsdGVkX1++bItZNP0Xc/7sIKwK/kpx9ol2NfwbU74="
}, {
    "num_cand": "U2FsdGVkX19rl7XTt1+sbbMqNTFBAtxAncPw8/QS2KM=",
    "cpf": "U2FsdGVkX1++w7G1bmbpmwxNQ+UvapEJxH1k8HpKlwQ="
}, {
    "num_cand": "U2FsdGVkX1+pUeFC4b+0O8w6Y4yWbC7J+NYBas7cg7g=",
    "cpf": "U2FsdGVkX19bnLZZLLRiB5HnsW2mGQWXYpQjwgRNc0U="
}, {
    "num_cand": "U2FsdGVkX19cOBohCbyLZhlRNbs2comoany4UWOjeD0=",
    "cpf": "U2FsdGVkX18gQOHQJVsnOOjCU+35e+tvAcv+nFbs+78="
}, {
    "num_cand": "U2FsdGVkX1848pUBZZ/h9aySUiHqKpYyYFer8qq60iA=",
    "cpf": "U2FsdGVkX1/Tir8yatdx5qGFlyJrzY+hgRPMVtAwVQ8="
}, {
    "num_cand": "U2FsdGVkX1/U6JGfKF9gjJuw+hYDV3c4Dg44/LPVuVw=",
    "cpf": "U2FsdGVkX1/FTBOqHCpmIXTCJf/QqAlY7p1jEXxBwlM="
}, {
    "num_cand": "U2FsdGVkX19c73T2Z5SPc/4WOt2UteRULBredoyZl1o=",
    "cpf": "U2FsdGVkX1/eQGrLG0PSRwMsG4eySRBD93nqrVSQA8w="
}, {
    "num_cand": "U2FsdGVkX19EJFa/9cXkxRFjyzkjcqkTnHOZy2M+vCg=",
    "cpf": "U2FsdGVkX1+ZqJN8fSfgtb+sNUTweCDzu11v46g/GRE="
}, {
    "num_cand": "U2FsdGVkX1/LelHOspi4izmDrc8lSolY2asD24rc9zs=",
    "cpf": "U2FsdGVkX1+N/Q0E+kOi9BKcf9GEkVUfser7/vaL1oY="
}, {
    "num_cand": "U2FsdGVkX19zyX/QXFMomVyw50QYp6bha01ktV6Stjg=",
    "cpf": "U2FsdGVkX1/QFxbOyTQmuCRYjJph0vIMyzyCEaarut4="
}, {
    "num_cand": "U2FsdGVkX1/xG3ciT/C41MvfGeE8XGfxcMKe1GODhSg=",
    "cpf": "U2FsdGVkX1/fiI4umUaXw3z/Kt/we3XhQonQnNqkjiU="
}, {
    "num_cand": "U2FsdGVkX1+XUYyVSFF/A7xv6WspE7QH6CaanvXhX1c=",
    "cpf": "U2FsdGVkX1+qx2pmFu/jH5YBbqgONm9dIqjgtUqMwDE="
}, {
    "num_cand": "U2FsdGVkX191c0+Gc+CnOfUmYeJjtQAtcm1OaqLu80E=",
    "cpf": "U2FsdGVkX19WSTDJflgK6K2DGrJTkawIdnlQesEbsCI="
}, {
    "num_cand": "U2FsdGVkX18L2lYEdlAC6W1ZF2+XuphMctQqSn3Kwy4=",
    "cpf": "U2FsdGVkX1/ax6+d8J9IlnU0ZbNL93EOL0563fzXzUY="
}, {
    "num_cand": "U2FsdGVkX18KpOiNX1pcaDEgCQYTiLt+Bl3oHHfzf4g=",
    "cpf": "U2FsdGVkX186S7/P+ZwZh9PWoZQgwMuOM9bNDirNmVI="
}, {
    "num_cand": "U2FsdGVkX18LDnBGK+R+o+oen/jDeipdT18MrmjBHdY=",
    "cpf": "U2FsdGVkX19rsWXteoIejYHyAOVn5ClBEu3f6KBe3JU="
}, {
    "num_cand": "U2FsdGVkX19KumQUWUrZHPo+RZZSRQ+BAXRvScY1PJc=",
    "cpf": "U2FsdGVkX186sFhK5q9/WLv8KopbYHbWOWfca0enGA0="
}, {
    "num_cand": "U2FsdGVkX18+fHIsFDysiQ0sEGL/BX32iQcjdVq/j2Y=",
    "cpf": "U2FsdGVkX1+Vq6B8iGrithPYNY6X6qgWdywY7flAnD8="
}, {
    "num_cand": "U2FsdGVkX1/shbdF0u5mCN2PoiPwtR6oIxwgd7sM1qU=",
    "cpf": "U2FsdGVkX18zX8hiMSLhyo/Lp0g2eKHggFLWhlTDlwg="
}, {
    "num_cand": "U2FsdGVkX18czJXhh6GsLgM/sbDKiC1ShixCtYzpXLk=",
    "cpf": "U2FsdGVkX1/ZrTlDhwAT7tpTgJDg80IIWgESpYwDcuQ="
}, {
    "num_cand": "U2FsdGVkX19amji3Of5QXUt5uPEG0xYVgQANr5Yz8D4=",
    "cpf": "U2FsdGVkX1+oPj3aXiRqhlQwCke8IDwfMtRieLPb1i8="
}, {
    "num_cand": "U2FsdGVkX181ZEH4oMVtXyEgd+rTDhKPpGcdUKJQ/dI=",
    "cpf": "U2FsdGVkX1/o8qdXiw3o25a+SeMy4Vvf12EtqJE4Y4k="
}, {
    "num_cand": "U2FsdGVkX1+ycOMF+gHJtJRPEW4qby1wa4Nlqwy29g4=",
    "cpf": "U2FsdGVkX18S3JttEGYkZjlqU3MCMkTEd4sA7Ukp54U="
}, {
    "num_cand": "U2FsdGVkX1/EXEeULsEX6y4ZOU2FVkYZKWbpDFGLzs8=",
    "cpf": "U2FsdGVkX18FEsUNmCu9sscONqJ4T5yOV/wxrAf2Tuc="
}, {
    "num_cand": "U2FsdGVkX19GyLKKOSZcznZ8/0hOgCcGiCqaQlsX9xw=",
    "cpf": "U2FsdGVkX19XRxx2IgwVsf1Nu71h0NtKuAeb16OmuME="
}, {
    "num_cand": "U2FsdGVkX18DyiVtLAR2U+C1TYM6Okl+O9vEL+YZiuQ=",
    "cpf": "U2FsdGVkX19ELIpt1PNXfZNSqPwtjkqjc8hNQmyNsOk="
}, {
    "num_cand": "U2FsdGVkX1/ZwQetTv6d5xd3TnBLuzG6Pha5Y1IxiqY=",
    "cpf": "U2FsdGVkX1+ghhU0cmsCpZdny5eitHPnEUwZJ7+WrfE="
}, {
    "num_cand": "U2FsdGVkX1+K8E/l6V/l+hTUXVeXZuoZd2SPNAplSjo=",
    "cpf": "U2FsdGVkX1+a1bWewOpWAPMnTsZYa5opDCFqrqA4lUA="
}, {
    "num_cand": "U2FsdGVkX1+dDM2DKPZZwKspkNeGXrLkAzVa/dP6914=",
    "cpf": "U2FsdGVkX1/tID1nvq1Hp80VFnaptDgtv3tMpIKX7Is="
}, {
    "num_cand": "U2FsdGVkX19/S1syqEKVxVzl0C7dJV7WcFXzTdVfkK8=",
    "cpf": "U2FsdGVkX1+2aVIDXN/IADPvDGmhCw9l+95c9RPTeNM="
}, {
    "num_cand": "U2FsdGVkX1+djSNOrGJWdEJfMWkVw2v3mP4fgRoFSnc=",
    "cpf": "U2FsdGVkX1/gT7N9YAFf0CxaMRlYalsvAnCehMFOqcI="
}, {
    "num_cand": "U2FsdGVkX194DZ7GvtiABusykS/YdW/uKF8fGmuvw+M=",
    "cpf": "U2FsdGVkX1/4CavlicAJUkCEfAFJ+53SGRoyTALqKAo="
}, {
    "num_cand": "U2FsdGVkX1+QSC7PrQBHGEdoG6hSVlcJOUvGmfcwGgU=",
    "cpf": "U2FsdGVkX19b95kbKnXmVANInhfv8Ae7uVF53o7p3mc="
}, {
    "num_cand": "U2FsdGVkX1+vUNsw6+GHyQFH7XMw3BGgWaIUO20AvYY=",
    "cpf": "U2FsdGVkX1+yqaycEvBD1iQz/WVc3MnZxaJ+01bUdG8="
}, {
    "num_cand": "U2FsdGVkX19NsJWCsaSQVyvMwoWGTZymHNAz5gmT/88=",
    "cpf": "U2FsdGVkX18NzdNKCym5vxzuN1bUofUs7LBzKqAaw6M="
}, {
    "num_cand": "U2FsdGVkX19+KcQJT62Fd4oX9JInEoIdOd//5FVCphs=",
    "cpf": "U2FsdGVkX192Tan7rdgzS1wObJ5GbwDMnsSQJ6bPP1M="
}, {
    "num_cand": "U2FsdGVkX18OyjO4T/SOBGHgiAkrF4HXYm6V/F53s0M=",
    "cpf": "U2FsdGVkX1/izusseNWIn+VLWTKPE61Zfo4Xyp/5vj0="
}, {
    "num_cand": "U2FsdGVkX18fdFBgsIqYLp3x7tMAKVykFIEzVMbQde0=",
    "cpf": "U2FsdGVkX1+8rVQ2nmTm6HneI1563VPNIsulBqwPb5k="
}, {
    "num_cand": "U2FsdGVkX1/DBdlD6AXUSh2mFsV3DI+7L0n1+MdxPUM=",
    "cpf": "U2FsdGVkX1+Ri05KBAaDRGVdABTsg/qzAo5uF/nDFtw="
}, {
    "num_cand": "U2FsdGVkX19vBWxcmoU25cOdk+qb33orxK0CSLXN6jg=",
    "cpf": "U2FsdGVkX1+CkUfeW39BQycXy6HlIh6eEUx0b/G92pE="
}, {
    "num_cand": "U2FsdGVkX1+DXo1JHwQR1AdacZLHmrKb1pxWik6rEaM=",
    "cpf": "U2FsdGVkX19b8r3Ty9p6Zt4h3N26Naq1jK0wUq0PhJ4="
}, {
    "num_cand": "U2FsdGVkX18jRUe23tQjMg02KMAR7qgZa/xKBWZEnEA=",
    "cpf": "U2FsdGVkX1+ptQ5TFHPW3vDGC9f/mjflHYTzBokPO/k="
}, {
    "num_cand": "U2FsdGVkX19t0MtF+eodFpQu4AHPKMYnAcOPNInLnAU=",
    "cpf": "U2FsdGVkX19ZB0Xg+ErNBzy0zkWHEohV+H6pt7c0KCw="
}, {
    "num_cand": "U2FsdGVkX1+QgpweP7pnXpyrroChUQlREjkz2o+0Bto=",
    "cpf": "U2FsdGVkX18Ekeo+fV+0BM7UtPNiJwZPvkW/AGAkJls="
}, {
    "num_cand": "U2FsdGVkX19+cUQL/hcPDJQfDoX5WwcXrOBKqVc4qCo=",
    "cpf": "U2FsdGVkX196zr27QVWIycJ76hVlaNc2bH2FR5tK/wM="
}, {
    "num_cand": "U2FsdGVkX18PHT+U911+KNvlUSThn1QtOVFt3wCr7/0=",
    "cpf": "U2FsdGVkX19Zqw98CS21HQ7d4TGhyrWZpbx6YFyGmog="
}, {
    "num_cand": "U2FsdGVkX1+BXHc5L5C4yyodKAZkhgi876y30SK9Jic=",
    "cpf": "U2FsdGVkX1969ED56WaauTj95jMbbMB3FQnoFzIymh8="
}, {
    "num_cand": "U2FsdGVkX1+XxRWRVbqKfiEsN7r1gmCMOKhwLOfQ0n4=",
    "cpf": "U2FsdGVkX1/lH5ZuRf+sZRywr3MDOwMKP28SoB85x0U="
}, {
    "num_cand": "U2FsdGVkX1+c8hlL5Hwh9X0sNBqADHm0pJKAW6DVqB4=",
    "cpf": "U2FsdGVkX1+WnQeQ+2VwOeaHFT+dHLoV/7KLRHMn4ek="
}, {
    "num_cand": "U2FsdGVkX18m4+nIgWAwVGKvOZsoyVxxYm9VwOnKetQ=",
    "cpf": "U2FsdGVkX1/FzUjMciAjyt+4lfPrfd5KlejDhRWQz3M="
}, {
    "num_cand": "U2FsdGVkX1/MTzxpSOo99xQ23gxfpXgSXx2yz1+bW88=",
    "cpf": "U2FsdGVkX1/ufSPHieGWHK0kiBGSOBu6QilVfvjO9uc="
}, {
    "num_cand": "U2FsdGVkX1+wfX2Sw+8GZFKXKFIyIwgaJQDyHdvzrxA=",
    "cpf": "U2FsdGVkX1+FXRbEoMgnlKeJUXe0L04nTVZzq9aEQSg="
}, {
    "num_cand": "U2FsdGVkX19NUEf/E4ALW/er0g6hWtmqISVgvo0K9G8=",
    "cpf": "U2FsdGVkX1+H/35nGQCeoxGUkQRzENEcvlfxGLipIRw="
}, {
    "num_cand": "U2FsdGVkX19cljJNj9TAWCwbWYWBWmWueMFusBFNVfw=",
    "cpf": "U2FsdGVkX19XRLPaenK9Y1FQTyEr0sy5FXT7vWY9TqI="
}, {
    "num_cand": "U2FsdGVkX19Pch5lZkkYwSts33jX5tO6YcsaJjI7q3k=",
    "cpf": "U2FsdGVkX18mdtGi4crjHXvvlHVUt8wNqHTQCnHKFPQ="
}, {
    "num_cand": "U2FsdGVkX18HlgFoDGcm1fX0c0lnq2210ifRWU7kho0=",
    "cpf": "U2FsdGVkX197hbyiX/XCRLD2CqysruwgeouNig2z47g="
}, {
    "num_cand": "U2FsdGVkX1/X3g5bK9DqB7DmULUayygpU5uesbkgkyI=",
    "cpf": "U2FsdGVkX1/lyuWX/eIJuZ6Cl3N+7lw90Uutb+VtUNk="
}, {
    "num_cand": "U2FsdGVkX1+oXKWoO4PyHzkBEyuN4JHL8wV+eyS8c3A=",
    "cpf": "U2FsdGVkX18y4kiH+A1MKjfmI69UWuBLTEIb+liOTKw="
}, {
    "num_cand": "U2FsdGVkX18C6bSAe/f/ZTBYDTXdtata+kDrfq1tpEQ=",
    "cpf": "U2FsdGVkX1+wRd/C5hHMXdy+Gn0jXCEmDqcYak4B6us="
}, {
    "num_cand": "U2FsdGVkX1/Rqf2cr9A9vYua73XN5/bxIvHNRR/9HLQ=",
    "cpf": "U2FsdGVkX1+0qr2EP0T86dclQR61isbwayzzO12KwNY="
}, {
    "num_cand": "U2FsdGVkX1//GvRmPvUcj1erww0lbAPDoPxomMLEH8o=",
    "cpf": "U2FsdGVkX18roGHf8FZ3Ym2Hk4UJkbU2tEVyspSYtV0="
}, {
    "num_cand": "U2FsdGVkX1+M57l2jMs0qNL9dlVWQMfteQ22nWS6aX0=",
    "cpf": "U2FsdGVkX1+MiyhR/cNyO7aUM9nKeyfVmbBXjT7Pdac="
}, {
    "num_cand": "U2FsdGVkX18m9zVZ/l4dFZrsYOxc5PJ47Erk4W4eTw0=",
    "cpf": "U2FsdGVkX1/To27lEAoIYi4F9v5YM1hhOWiXMdsxAV0="
}, {
    "num_cand": "U2FsdGVkX18jsyfeoQ6vMgnGBWxmJVlz9S+5gBEkS+E=",
    "cpf": "U2FsdGVkX18Igutl4lfQzWKnJXtoGLlIiisFtWS6mhc="
}, {
    "num_cand": "U2FsdGVkX19Z9ShftZJ8S0IsQxZhZNBpeHpEWMVb1WA=",
    "cpf": "U2FsdGVkX1+h249s1PHRB/Z7t5h7TKqP43mslfoejpM="
}, {
    "num_cand": "U2FsdGVkX1+zVby6arrspjceJPH5KB+Nv87cc+iJOxU=",
    "cpf": "U2FsdGVkX19xuWaQTsnaPb31SXQW+2lH+c0wiZn9TRc="
}, {
    "num_cand": "U2FsdGVkX1/hNpR4d/IwAOS6onrykeeKuVTX1gctMAw=",
    "cpf": "U2FsdGVkX18BRm42cGK375oHOoylYyQXdUYNgY2qoCQ="
}, {
    "num_cand": "U2FsdGVkX19QujJW9Ki9DExHQYQryFzj82mC/btsV8o=",
    "cpf": "U2FsdGVkX1/ZDnrw6Z+1uZCvRLVC/1eqjIWQVbLlEcY="
}, {
    "num_cand": "U2FsdGVkX19ppSs4cAiq6BA+Sx7S7GCwHgUZAsI3eeY=",
    "cpf": "U2FsdGVkX1/ES5qXcOZwH2rLMZ3fZQC7HhUVR6odq88="
}, {
    "num_cand": "U2FsdGVkX18ccy5SzQO6lc0Jl56H7ay+D92B+Rhw95U=",
    "cpf": "U2FsdGVkX18zFvRMjpi9aIz41TyFTGpFdbX1+fJrLO4="
}, {
    "num_cand": "U2FsdGVkX1/B3K0XaIxwBx9Lm4QNkYzJJAJAUZwuSdU=",
    "cpf": "U2FsdGVkX1/Vd1ppQK+6OWdzQqXmtaAWbPy02aZsHa8="
}, {
    "num_cand": "U2FsdGVkX1/kKf9Eb0V964QhetGHEdVZKNsUPbjTSuA=",
    "cpf": "U2FsdGVkX1/22YtqOca+ci3yS+LM9w73UY+4Yvg54/A="
}, {
    "num_cand": "U2FsdGVkX1/GolBJS2ErJYyap6FysBPkv9ojwwdrQQ4=",
    "cpf": "U2FsdGVkX18i8OvxTZU7gGREG7dZh9goYZCiph+pz00="
}, {
    "num_cand": "U2FsdGVkX19vnJMTJtBSNacm1iKWC4DxJrMQYVEDjik=",
    "cpf": "U2FsdGVkX1/7ZF0DGB0C+JyVHHg6jLlilFvWiLrfog8="
}, {
    "num_cand": "U2FsdGVkX1/vb/LOdPHmSjKjLleh01w2fVOqwrRplv4=",
    "cpf": "U2FsdGVkX1933TlE4lCOQ/9WYaDkKMitEveGWG6udoA="
}, {
    "num_cand": "U2FsdGVkX1+CK2Jad5vJzpamlivD6NRM2zDvDukC8nI=",
    "cpf": "U2FsdGVkX1/gO7K3HeOZJZJeC4qM7X7vGpvf86CiWMY="
}, {
    "num_cand": "U2FsdGVkX19hMmdFa5jff3V1FWRz8eEDV4XOiPwGwjk=",
    "cpf": "U2FsdGVkX19f/pSClDwcn2/NX/6CpOdF7qrgKjc60Ro="
}, {
    "num_cand": "U2FsdGVkX19qbFZ1X58HaVAcD38a2t2S+7Z36eS3wP4=",
    "cpf": "U2FsdGVkX18Lls0Jlae+lL/JHK0NulJXLetcjZHsoqI="
}, {
    "num_cand": "U2FsdGVkX18y6JbgJ+vptMDiWAX3N/Q+YbV2JX0EAok=",
    "cpf": "U2FsdGVkX19dozUO+r+8RgY+5mxMGd/ccmoBLI7GkuE="
}, {
    "num_cand": "U2FsdGVkX1/zn1bHwappEF5weJ3HTi6nVodBq3Tj2ZY=",
    "cpf": "U2FsdGVkX1/z3ReWUqw+dEXIG2xVqf9DflDWqyAIfDM="
}, {
    "num_cand": "U2FsdGVkX19ZorljE1ySh9wDKIXLxd11HHgiJXqapTE=",
    "cpf": "U2FsdGVkX1+VjPGtAxKKXlJ3F1MN62dUwHW5147btew="
}, {
    "num_cand": "U2FsdGVkX1+gqFBHv7+Pac1VbdUwyXJT9KSXqovxy6M=",
    "cpf": "U2FsdGVkX1/VlmFzhlvs1gBaPDRl5ceOSeSvQfTdl2c="
}, {
    "num_cand": "U2FsdGVkX1+FepfsHujPIOwpR8CW5idoj3W4aUWKZR4=",
    "cpf": "U2FsdGVkX19aPK7wR1qsm4HH7qH0gtRLQ4iqNkWo9TY="
}, {
    "num_cand": "U2FsdGVkX19If3k0tY8VPbQlAB/JuTTkEgIBEyOOk9g=",
    "cpf": "U2FsdGVkX1/Mm7WK7XFmQm7fxBmM5TmcDYKw++n1+As="
}, {
    "num_cand": "U2FsdGVkX1/WWfxfhC1yXCcHZdShwxomlHgsWdwYTx0=",
    "cpf": "U2FsdGVkX1+DtPlCp0kIcY8t7vvONz0JS5CWfanqB5Y="
}, {
    "num_cand": "U2FsdGVkX18zOqjhSvy82PiVO4K4n3qVvhKbWGF8mFI=",
    "cpf": "U2FsdGVkX19Mkoahw9UoR8IBU9nUnTqVUc4kQ3S2AkM="
}, {
    "num_cand": "U2FsdGVkX19O2hhhkCfuVdl1DTWYm5IoCgnaSw0/Q9I=",
    "cpf": "U2FsdGVkX19qR/RZNJJAOPWpcZz+fTXsmYpotcvVURk="
}, {
    "num_cand": "U2FsdGVkX18aN3IQ1PqVA3Cpx6FSiLsbyuNJ89ewGPw=",
    "cpf": "U2FsdGVkX1+DwVRcRSH6fzJSevi/ghHZ1KMJo94dGq8="
}, {
    "num_cand": "U2FsdGVkX18lDKIdwgj335mbheyq3Fx4mVOzIquhd7Y=",
    "cpf": "U2FsdGVkX1+Xx98u96N4xFGth1GrVpzXSB2RO8dJ1ME="
}, {
    "num_cand": "U2FsdGVkX18C4wtGugTkj+wRzf5/Mpj3hAEBuisytTk=",
    "cpf": "U2FsdGVkX1+lxBsdbyZX93Zk42FLdjLGTPDmPil5yss="
}, {
    "num_cand": "U2FsdGVkX1/vpsiVBfpJuK5AkWxch7RW4W4e8Yvt00Q=",
    "cpf": "U2FsdGVkX18yKcHaEvocFzVcF1XePjzIO3WdKUHsTyc="
}, {
    "num_cand": "U2FsdGVkX1/rTXK4dLvlj5JRkKphHa/979FIwo4A62Y=",
    "cpf": "U2FsdGVkX1/TaBjXVhrGuky9XT0oW11mrbQnfLX+KA8="
}, {
    "num_cand": "U2FsdGVkX1+8PfENWPDMFDgoeJEjrPMJdpVh3IhpKFg=",
    "cpf": "U2FsdGVkX1972Msokss3Pbo82YTKp0K4RgfpuUzvJXE="
}, {
    "num_cand": "U2FsdGVkX1+CMt8gd231RB4g9PWZFAyIB4u/s4zQ8BM=",
    "cpf": "U2FsdGVkX1+RE+1JHyd+25HL2m53O45QVoR9pUBm8ZA="
}, {
    "num_cand": "U2FsdGVkX19dmXu+BjVlcUNz+qVxLvR6Dt5mkOBzjw4=",
    "cpf": "U2FsdGVkX1+A3b4ipNRXZZXQxLOLRE1da2vFpcDb1Vc="
}, {
    "num_cand": "U2FsdGVkX1+25ln9PBZDx3csy1sPNPYiYn8zSJubHoQ=",
    "cpf": "U2FsdGVkX18p0lxxGrTC61FtNvHpA0OJvt6m7HZsd+E="
}, {
    "num_cand": "U2FsdGVkX18DHWm5OwIDccUT5RQTr/JeCC2VY0PXWXw=",
    "cpf": "U2FsdGVkX18mQpqsCycgVNdYVvwj5/jPS0LN7eS9aGY="
}, {
    "num_cand": "U2FsdGVkX19sN3Ew4wuAa0lmEqAJ00uHWekva8KnN+8=",
    "cpf": "U2FsdGVkX1/G6ru4paHyqGxH+iaP+xAEd26nEEoWw/8="
}, {
    "num_cand": "U2FsdGVkX18gkT+DM0VI54yRDf7raqJVjvrmT3PGh9Q=",
    "cpf": "U2FsdGVkX1+jT9sMAIEVMEwt84Lrg4ouMB9fNOL0Ebs="
}, {
    "num_cand": "U2FsdGVkX18Q9osV6XwH9CtQ16pvqVUaaXvkkwa2VF8=",
    "cpf": "U2FsdGVkX18zRpfWu+fSEKDSk5Qnwqhe4EJE9FOUTpw="
}, {
    "num_cand": "U2FsdGVkX19VHmYwXRR+v1zvAeZWXTZIyRjua7t/adA=",
    "cpf": "U2FsdGVkX1/3Tzhuf/emB1Ve4YMYsw42BXi/ZoTk4Fw="
}, {
    "num_cand": "U2FsdGVkX1+qgYsX4JOEcemntGPq9EH5TZe8j/STCmM=",
    "cpf": "U2FsdGVkX1/qR3lB53KJzTRc5a6Wr/rvs8Ob69uuJWM="
}, {
    "num_cand": "U2FsdGVkX1/7Lf9V5OJEsa4XrUuF9O6cc6EJm/tvlqU=",
    "cpf": "U2FsdGVkX18ZousIE/1JDbEh7pQ3pqx6HGRfecpG4zA="
}, {
    "num_cand": "U2FsdGVkX193ihBwnKpGEQ9I+ZpTrWkPFToCi54nfDM=",
    "cpf": "U2FsdGVkX19jny6Tnmq+dXMZTc0/3XsJX2+dzFdWgxs="
}, {
    "num_cand": "U2FsdGVkX1+zXYVriBi5jRStXqJAjpL2zRMW4k8rqFM=",
    "cpf": "U2FsdGVkX1+uvANB3ry3+0mIyQks4g9lx+F/ssVCVYg="
}, {
    "num_cand": "U2FsdGVkX19GSUa5xclyNo0ejDL0c9x5w9KCgYCWtJ0=",
    "cpf": "U2FsdGVkX1+d4mDr04ex3brYpy1ADBx2n9CJ0KmEcfI="
}, {
    "num_cand": "U2FsdGVkX187POjB9ejCvhZ3zJMHCl1fOvXx38wG1s0=",
    "cpf": "U2FsdGVkX19Zxqoby2bmYLErC7mrSOhYHT65pVMO0fc="
}, {
    "num_cand": "U2FsdGVkX1+84PT523J4ADJCK3eumE7nSzBOxKco9VA=",
    "cpf": "U2FsdGVkX18ybeZDp7KS8comTuWv4/VJY5a+X6rxI+0="
}, {
    "num_cand": "U2FsdGVkX1/Tu40cj5OXjfT412UTZpxUKJaezhlTg4Q=",
    "cpf": "U2FsdGVkX19Q0CGYlcIjgyXWk4K49kx/gKJaJ0SJvkw="
}, {
    "num_cand": "U2FsdGVkX1/lLngi6VBD33m3bwnh6UGZ86pIOi0UXqw=",
    "cpf": "U2FsdGVkX19DWSadxa3Krem4vCJw/UZgr0urycDu8pk="
}, {
    "num_cand": "U2FsdGVkX19dRxzEbVp0lZqsBkiSvZ4d+ihr7vSbbig=",
    "cpf": "U2FsdGVkX18uAJHq+NxtzKo3Wxh3Wkg3E85pte4ubSg="
}, {
    "num_cand": "U2FsdGVkX18PLqD2gfB94meLCJCfvzVyIqY/vSxP+vQ=",
    "cpf": "U2FsdGVkX19AtulEgTCSEUspwJbj8xp5GOc/9Te/64Y="
}, {
    "num_cand": "U2FsdGVkX191pGAvFIU3nFAEgUVpygdxE+ARfTi07Zs=",
    "cpf": "U2FsdGVkX1/DE937zeANvj8w/ePmmxl6GuGOAZRHRpg="
}, {
    "num_cand": "U2FsdGVkX195RVV8JWRd7b3PlN5LReZRuSqWBqhVXNA=",
    "cpf": "U2FsdGVkX18kpolgqUWph6jgAoHTJSSpvUse+cSLthI="
}, {
    "num_cand": "U2FsdGVkX19jNtEpAXMMdJXiN8mtEBfJPo0yoZ0FvEg=",
    "cpf": "U2FsdGVkX185bRdKvWskTuF8UvTnljG708HWTY4XbAU="
}, {
    "num_cand": "U2FsdGVkX19chLGkFOQfHnXFfqS3yDe+2/WRly2rlyo=",
    "cpf": "U2FsdGVkX1+sRyDwLod8oLIl0xyx3c9mQE+8nFJRu2w="
}, {
    "num_cand": "U2FsdGVkX183Pt8jax3Wf04tZRyHc/oxHnvv8uyUhI8=",
    "cpf": "U2FsdGVkX18zLI9Od4GMy9maQFf2LQf7+ISKvJqx2xk="
}, {
    "num_cand": "U2FsdGVkX18kd7IBSm3s5ax8m+gEBW4xWyVt8ctmm1o=",
    "cpf": "U2FsdGVkX1/u7DoC8on3m21Sig9jhyd0VOJGr+nSHso="
}, {
    "num_cand": "U2FsdGVkX1/F0cV2F5wMpWf/pyp1TlEtjZRIrgJ+9TU=",
    "cpf": "U2FsdGVkX184Lf+44/O1yXxbSWhiLKDDHYEKhT7lYUU="
}, {
    "num_cand": "U2FsdGVkX1/SMO6pY6xzuVs2ZpYQYVPFBy/NQZ1P4s8=",
    "cpf": "U2FsdGVkX19VG4ftCTLfoGnuiwa8mK05qoKVsF949hU="
}, {
    "num_cand": "U2FsdGVkX18gJ+RsaN+/85FsRXbNUu8PWJgPVE9Ft6M=",
    "cpf": "U2FsdGVkX1/fU0SSZTjdIF5UTf+8uO1NjxCWHvKoM6I="
}, {
    "num_cand": "U2FsdGVkX1/4tcgt49hpItNX9zfqtzNsurwOyfshRFg=",
    "cpf": "U2FsdGVkX18DTt4jfbIoFNIDgw389pyloiYQSwmr7Zc="
}, {
    "num_cand": "U2FsdGVkX1/N6I/988yjPAWu/28i/9MhmsXd9hR+3iY=",
    "cpf": "U2FsdGVkX18Uq01SMMacaH7/tGpggqJRnNLCa4ORomU="
}, {
    "num_cand": "U2FsdGVkX1/OuRfTxQGdEjz2mbhdYcTDq/whZwHqiBo=",
    "cpf": "U2FsdGVkX1+ip56rrazmXQMeWWtmCOmesmvBPvn6D5E="
}, {
    "num_cand": "U2FsdGVkX19M9v9R/gPBoUcIwO3AcRyNojvzxWzdNbU=",
    "cpf": "U2FsdGVkX1+awtt/OsOiK9e2SzJFOiEALFRmVYy/c+c="
}, {
    "num_cand": "U2FsdGVkX19cccxSCSp2eUNLW36tWDHSnXXvDDYdZ3g=",
    "cpf": "U2FsdGVkX1/5hKutRwLFpd97Xgx4Z4u6Yzl3LX83kmQ="
}, {
    "num_cand": "U2FsdGVkX197br9SKxWJGJ6sXRFT3XQf4zidKIMlizU=",
    "cpf": "U2FsdGVkX18l7ezi2WXKbceJsyE/dz0Pqc4VNmNGwmw="
}, {
    "num_cand": "U2FsdGVkX18XoEhfwmgaec1qyiEo4a7W4vxmVVzqYfo=",
    "cpf": "U2FsdGVkX19eGRjrR2ZsYwczyywAB1Y2jWzKau7Byw0="
}, {
    "num_cand": "U2FsdGVkX1+wNOJ7073L/8z5XaVgS13jyyP5/umhHjU=",
    "cpf": "U2FsdGVkX18g4y9qaP2AHLAshjXQLx1H+1Sk/OiRq2c="
}, {
    "num_cand": "U2FsdGVkX1/qfVRbbjqtJ5hw2x15CWP23McsRWK9Nqk=",
    "cpf": "U2FsdGVkX1+GYb2FGvOnpRCZQAB4iQxYcEYsSaP7L5A="
}, {
    "num_cand": "U2FsdGVkX19Zp3OSRNKEbX1pTsIWxEu4k1DqVo5/bCA=",
    "cpf": "U2FsdGVkX18NxvKa0uCQJ0mv4MLdsvQSdAN6DO3CEvk="
}, {
    "num_cand": "U2FsdGVkX18wGXBJkahLuSaLgXi1B+We+Vhv/GbkZow=",
    "cpf": "U2FsdGVkX18QEhcAXk9Gcf3yfjG5jeEfTdCCPMSe7t0="
}, {
    "num_cand": "U2FsdGVkX1/YzIh+jbiLM+DW9977Rk9QqVXsV5cxPvU=",
    "cpf": "U2FsdGVkX187WaKGGuL5Id3N7WXQuLvRMdY879BLIRI="
}, {
    "num_cand": "U2FsdGVkX18dBgB0UfM9a+HXDY6W1pNIkWnVLnnKGX4=",
    "cpf": "U2FsdGVkX18RzTOQxqnY3kpI2n52LaJiZP2sXATtjhI="
}, {
    "num_cand": "U2FsdGVkX18jzDO0KIRZ+GRj71kkGtY5OHg5ik8R3zs=",
    "cpf": "U2FsdGVkX1/hOcV+UnZSms+m0UvJWASH9JCk88lIYVE="
}, {
    "num_cand": "U2FsdGVkX19f2YB9jeG0m2grz0tMMUSAwYv/WQIxaxY=",
    "cpf": "U2FsdGVkX1+VpYwOZp6bBIoiIvudAOdCAPn8g9jwvJ4="
}, {
    "num_cand": "U2FsdGVkX19X9A5/TW2/oG9C56TQQhgINFrtdn2B6rQ=",
    "cpf": "U2FsdGVkX19i31AqQoqFLS3TMZhx/tSZOTS7xubNbuw="
}, {
    "num_cand": "U2FsdGVkX1/yoEmj3XguAXjF5FwSCM76kY0QXZixV08=",
    "cpf": "U2FsdGVkX1+cOF+gcYph/ODPcuNSyBbOjUrFeGrGcy0="
},
    {"num_cand":"U2FsdGVkX19csCYaUXVT0EHP6hQ+4bXxYOwTG8ns5RA=","cpf":"U2FsdGVkX19c/Le9XWcop0mXhj41tvDcw0B3zBngZeg="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2208/res_DISC/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
